import Site from '@r6digital/rapidstor-types/types/Site';
// eslint-disable-file
const defaultLocations: Site[] = [
    //     {
    //         SiteID: 1758,
    //         sLocationCode: 'ASH',
    //         sGlobalSiteNum: '14466',
    //         iMobileType: '0',
    //         iRegionalOptions: 1,
    //         iOnLineChargeType: '0',
    //         bFeatMobileStorage: 'false',
    //         iGMTTimeOffset: 10,
    //         sLocationDesc: null,
    //         sSiteIDCode: null,
    //         sSiteRegionCode: null,
    //         sContactName: 'Billy Prescott',
    //         sEmailAddress: 'keswick@ustoreit.com.au',
    //         sSiteName: 'U-Store-It Keswick',
    //         sSiteAddr1: '70 Everard Avenue',
    //         sSiteAddr2: null,
    //         sSiteCity: 'Keswick',
    //         sSiteRegion: 'SA',
    //         sSitePostalCode: '5035',
    //         sSiteCountry: 'AUS',
    //         sSitePhone: '08 8297 8811',
    //         sSiteFAX: '.',
    //         sWebSiteURL: null,
    //         iFeatMaxUnits: '2000',
    //         bFeatGate: 'true',
    //         bFeatKiosk: 'true',
    //         bFeatRevMgmt: 'true',
    //         bFeatCreditCards: 'true',
    //         bFeatCorpOffice: 'true',
    //         bFeatAccounting: 'true',
    //         bFeatRecordStorage: 'false',
    //         bFeatACH: 'true',
    //         dACHStatus: '2014-10-20T09:19:34.277-04:00',
    //         bLiteVersion: 'false',
    //         bTrial: 'false',
    //         bSubscription: 'false',
    //         bSiteDisabled: 'false',
    //         dGateUpdated: '2024-03-16T08:27:05.457-04:00',
    //         dOvernightProcess: '2024-03-16T10:03:08.48-04:00',
    //         sLegalName: 'U-Store-It Pty Ltd',
    //         bZipCodeData_Use: 'false',
    //         dcLongitude: '138.5776520000',
    //         dcLatitude: '-34.9459880000',
    //         bClosedWeekdays: 'false',
    //         bClosedSaturday: 'false',
    //         bClosedSunday: 'true',
    //         dWeekdayStrt: '2010-05-24T08:30:00-04:00',
    //         dWeekdayEnd: '2010-05-24T17:00:59-04:00',
    //         dSaturdayStrt: '2010-05-24T08:30:00-04:00',
    //         dSaturdayEnd: '2010-05-24T16:00:59-04:00',
    //         dSundayStrt: '2010-05-24T08:30:00-04:00',
    //         dSundayEnd: '2010-05-24T12:00:59-04:00',
    //         bPermanent: 'false',
    //         dUpdated: '2024-03-16T14:03:08.480Z',
    //         uTS: 'AAAAABxQJKY=',
    //         bFeatPromoAdvanced: 'false',
    //         iIdentifier: '0',
    //         sIdentifier: null,
    //         bUseInclusiveTaxation: true,
    //         bArchived: 'false',
    //         iBusinessType: '-35',
    //         iSiteDataType: '0',
    //         sTaxNumber: '53 659 430 120',
    //         iFacilityUsage: '0',
    //         iFacilityOwnership: '0',
    //         iFacilityMgmt: '0',
    //         iFacilityLocType: '0',
    //         iMobileBungoRules: '0',
    //         dCreated: '2010-05-17T00:00:00-04:00',
    //         iOnLinePmtsAllowed: '1',
    //         iEdition: '1',
    //         iTerminalServices: '0',
    //         iDST: '0',
    //         iVerboseLogging: '0',
    //         iSiteLinkStoreTier: '1',
    //         sSLBillingRef: 'RAGASH',
    //         iSubscriptionType: '0',
    //         tWeekdayStrt: '08:30:00',
    //         tWeekdayEnd: '17:00:59',
    //         tSaturdayStrt: '08:30:00',
    //         tSaturdayEnd: '16:00:59',
    //         tSundayStrt: '08:30:00',
    //         tSundayEnd: '12:00:59',
    //         rapidstorEnabled: true,
    //         bForcePushRates: '0',
    //         iWebRatesType: '0',
    //         ownerId: '48',
    //         languageId: '1',
    //         divisionId: '24',
    //         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //         hours: {
    //             officeMondayOpen: '9:00am',
    //             officeTuesdayOpen: '9:00am',
    //             officeWednesdayOpen: '9:00am',
    //             officeThursdayOpen: '9:00am',
    //             officeFridayOpen: '9:00am',
    //             officeSaturdayOpen: '9:00am',
    //             officeSundayOpen: '9:00am',
    //             officeMondayClose: '5:00pm',
    //             officeTuesdayClose: '5:00pm',
    //             officeWednesdayClose: '5:00pm',
    //             officeThursdayClose: '5:00pm',
    //             officeFridayClose: '5:00pm',
    //             officeSaturdayClose: '5:00pm',
    //             officeSundayClose: '5:00pm',
    //             gateOpen: '9:00am',
    //             gateClose: '5:00pm',
    //             gateOpenWeekend: '9:00am',
    //             gateCloseWeekend: '5:00pm',
    //             gateCloseSaturday: '5:00pm',
    //             gateCloseSunday: '5:00pm',
    //             gateOpenSaturday: '9:00am',
    //             gateOpenSunday: '9:00am',
    //         },
    //         skin: {
    //             accentColours: {
    //                 primary: '#FFE700',
    //             },
    //             defaultUnitPicture: 'https://ik.imagekit.io/bytcx9plm/3x3_f.png',
    //             mainColour: '#ED1F15',
    //             highlightColour: '#CFD8DC',
    //             moveinTimeRemaining: false,
    //             themeColour: ''
    //         },
    //         administrative: {
    //             boxshopEnabled: true,
    //             testMode: false,
    //             rslite: false,
    //             rsliteKey: 'N/A',
    //             refreshEnabled: false,
    //             availableForUse: false,
    //             insuranceEnabled: false,
    //             merchEnabled: false,
    //             carouselListing: false,
    //             useMtasForAuth: false,
    //             featureAllowReservationsWhenNoAvailability: false,
    //             spacerIntegration: false,
    //             couponCloning: false
    //         },
    //         rapidstor: {
    //             pushRate: false,
    //             marketingSurvey: {
    //                 use: true,
    //                 questions: {
    //                     whereHearAboutUs: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     distanceFromFacility: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whyStoring: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     customerType: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whatStoring: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whyStoringWithUs: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                 },
    //             },
    //             country: 'AU',
    //             unitListing: {
    //                 sortOrder: {
    //                     primary: 'size',
    //                     secondary: 'price',
    //                     tertiary: 'availability',
    //                 },
    //                 useMultilevel: false,
    //             },
    //             siteLogo:
    //                 'https://ik.imagekit.io/bytcx9plm/CRAG-ASH-logo-cjrvbii0a0001f9morp0ztpmz.png',
    //             allowOriginUrl: [],
    //             allowedCreditCardTypes: {
    //                 visa: true,
    //                 mastercard: true,
    //                 amex: true,
    //             },
    //             facilitySelfService: {
    //                 enquiries: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-enquiries.png',
    //                 },
    //                 takePayment: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-take-payment.png',
    //                 },
    //                 moveOut: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-moveout.png',
    //                 },
    //                 boxshop: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-boxshop.png',
    //                 },
    //             },
    //             siteLinkLeaseFields: [],
    //             language: {
    //                 selectionOption: 'auto-detect',
    //             },
    //             useBoxShopCoupons: false,
    //             useDealCoupons: false,
    //             features: {
    //                 'movein-wizard': 'single-page',
    //                 'unit-listing': 'standard',
    //                 boxshop: 'standard',
    //                 'reservation-with-fee-wizard': 'standard',
    //                 'tiered-unit-listing': 'standard',
    //                 'facility-self-service': 'standard',
    //                 'facility-staff-self-service': 'standard',
    //                 'tenant-accounts': 'standard',
    //                 'carousel-unit-listing': 'standard',
    //             },
    //             paymentGateways: {
    //                 use: false,
    //                 gatewayToUse: '',
    //                 paypal: {
    //                     currency: '',
    //                     clientId: '',
    //                     clientSecret: '',
    //                 },
    //                 paytabs: {
    //                     merchantEmail: '',
    //                     secretKey: '',
    //                     merchantSiteUrl: '',
    //                     countryCode: '',
    //                     messageLanguage: '',
    //                     merchantId: '',
    //                     currency: ''
    //                 },
    //                 bypassSitelinkProcessing: false,
    //                 paygate: {
    //                     countryCode: '',
    //                     currency: '',
    //                     encryptionKey: '',
    //                     locale: '',
    //                     payMethod: '',
    //                     paygateId: '',
    //                 },
    //                 paynamics: {
    //                     countryCode: 'PH',
    //                     currency: '',
    //                     merchantId: '',
    //                     merchantKey: '',
    //                     merchantTermsUrl: '',
    //                     paymentMethods: ['bn', 'cc', 'dp', 'gc', 'pp'],
    //                     secure3d: 'try3d',
    //                 },
    //                 r6Pay: {
    //                     currency: '',
    //                     useTestEnv: false,
    //                 },
    //             },
    //             minAvailableUnits: 0,
    //             hideUnitsMinAvailable: false,
    //             noAvailableUnitsText: 'Call for Availability',
    //             hideQuickSearch: false,
    //             smallMediumSize: 6,
    //             mediumLargeSize: 13,
    //             moveinHideAcp: false,
    //             insuranceRequired: false,
    //             hideBoxshop: false,
    //             hideInsurance: false,
    //             hideLicense: false,
    //             hideLicenseState: true,
    //             hideDateOfBirth: true,
    //             hideState: false,
    //             hidePostalCode: false,
    //             autoOptInSms: false,
    //             currencySymbol: '$',
    //             sizeSymbol: 'm',
    //             groundFloor: 0,
    //             billingDefault: 'MonthlyAnniversary',
    //             shippingEnabled: false,
    //             legacyPickupLocationsEnabled: false,
    //             legacyPickupLocations: null,
    //             shippingInventoryItem: null,
    //             freeShippingDealEnabled: false,
    //             freeShippingDealAmount: 150,
    //             allowReservation: true,
    //             allowMoveIn: true,
    //             reservationNumberOfDaysInAdvanceLimit: 30,
    //             moveinNumberOfDaysInAdvanceLimit: 7,
    //             reservationNumberOfDaysInAdvanceChargeFee: 365,
    //             assistanceMoving: false,
    //             assistanceMovingEmailAddress: '',
    //             notificationsFromAddress: '',
    //             completeMoveinUrl: '',
    //             useESign: false,
    //             useAutoBilling: true,
    //             autoBillCheckedByDefault: false,
    //             doNotSendInvoiceSiteLinkWhenAutoBill: false,
    //             quickReserveButtonText: 'Quick Reserve',
    //             reservationExpireReservationDays: 30,
    //             notificationsAdditionalCcAddresses: [],
    //             areaSizeSymbol: 'm²',
    //             allowReservationsWhenNoAvailability: false,
    //             attachInsuranceDocsToMoveInConfirmationEmail: false,
    //             attachLeaseToMoveInConfirmationEmail: true,
    //             attachReceiptToMoveInConfirmationEmail: true,
    //             autoESignRedirect: false,
    //             autoOptInSMS: false,
    //             bookOnlineDiscount: 0,
    //             boxshopCategoryAlphaOrder: false,
    //             boxshopPurchaseAttachmentName: '',
    //             boxshopPurchaseEmailSubject: '',
    //             boxshopTermsConditions: '',
    //             checkForExistingTenant: false,
    //             completeMoveinURL: '',
    //             currency: 'AUD',
    //             dateFormat: 'yyyy-MM-dd',
    //             datesClosed: '',
    //             delayedInsurance: {
    //                 enabled: false,
    //                 timings: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //             },
    //             documentVerification: {
    //                 enabled: false,
    //                 providerToUse: null,
    //                 providers: {
    //                     rapidId: {
    //                         label: 'RapidID',
    //                         token: null,
    //                     },
    //                 },
    //             },
    //             eSignInsuranceForm: {
    //                 sFormName: null,
    //             },
    //             eSignInsuranceFormName: '',
    //             eSignMoveInDocumentNames: [],
    //             eSignMoveInDocuments: [],
    //             eSignReturnUrl: '',
    //             emailSchedules: {
    //                 quoteUnlockFirstReminder: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //                 quoteUnlockSecondReminder: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //                 reservationNotMovedIn: {
    //                     days: null,
    //                     hours: null,
    //                     mintues: null,
    //                 },
    //                 quoteEmail: {
    //                     '1': {
    //                         subject: null,
    //                     },
    //                     '2': {
    //                         days: null,
    //                         hours: null,
    //                         minutes: null,
    //                         subject: null,
    //                     },
    //                     '3': {
    //                         days: null,
    //                         hours: null,
    //                         minutes: null,
    //                         subject: null,
    //                     },
    //                 },
    //             },
    //             enquiryAPI: {
    //                 numOptions: 3,
    //             },
    //             forceTaxInclusive: false,
    //             hidePrices: false,
    //             includeFutureMoveOut: false,
    //             includeReservedUnitsInOccupied: true,
    //             insuranceCustomFormat: '',
    //             insuranceEsignReturnUrl: '',
    //             insurancePolicyNumberRange: {
    //                 end: null,
    //                 start: null,
    //             },
    //             insurancePolicyNumberRefreshNum: null,
    //             insuranceSmsFollowUpContent: '',
    //             kioskUnitListing: 'standard',
    //             locationPageUrl: '',
    //             moveinEmailSubject: '',
    //             moveinHideACP: false,
    //             moveinRedirectUrl: '',
    //             notificationsAdditionalBCCAddresses: [],
    //             notificationsAdditionalCCAddresses: [],
    //             notificationsFromName: '',
    //             notificationsReplyAddress: '',
    //             payLaterButtonText: 'Pay Later',
    //             payNowButtonText: 'Pay Now',
    //             pickupEnabled: true,
    //             recaptcha: {
    //                 enabled: false,
    //                 secretKey: '',
    //                 siteKey: '',
    //                 tolerance: 0.5,
    //             },
    //             reservationEmailSubject: '',
    //             reservationExpireOccupancyValues: {
    //                 bands: [
    //                     {
    //                         days: 30,
    //                         from: 0,
    //                         to: 100,
    //                     },
    //                 ],
    //                 enabled: false,
    //             },
    //             reservationPopupText: '',
    //             resetPasswordUrl: '',
    //             scheduleFollowUpEmails: false,
    //             showAreaInsteadOfDimensions: false,
    //             showAutobillTerms: false,
    //             showMoveInDateLimitMessage: false,
    //             showPricesButtonText: 'Show Prices',
    //             showPricesShowNeeded: true,
    //             showVehicleQuickSearch: false,
    //             showWeeklyRates: false,
    //             siteOpeningDate: null,
    //             sitelinkCostRetrieveChargeNameSubstiutions: [],
    //             spaceCalculatorValues: {
    //                 bedroom: 4,
    //                 box: 0.05,
    //                 garage: 7,
    //                 highestValue: {
    //                     area: 20,
    //                     high: 30,
    //                     low: 18,
    //                 },
    //                 largeItem: 1.5,
    //                 largeRoom: 5,
    //                 lowestValue: {
    //                     area: 3,
    //                     high: 5,
    //                     low: 1,
    //                 },
    //                 room: 4,
    //                 smallItem: 0.5,
    //                 smallRoom: 3,
    //             },
    //             tenantAccounts: {
    //                 autoPayment: {
    //                     enabled: true,
    //                 },
    //                 invoiceHistory: {
    //                     enabled: true,
    //                     showChargeBatch: false
    //                 },
    //                 makePayment: {
    //                     enabled: true,
    //                 },
    //                 paymentHistory: {
    //                     enabled: true,
    //                 },
    //                 tenantInfo: {
    //                     enabled: true,
    //                 },
    //                 uploadDocuments: {
    //                     enabled: true,
    //                     generalContent:
    //                         'Please select & upload the following documents as a pdf or image.',
    //                     proofOfAddress: {
    //                         content:
    //                             'Please upload a photo which has proof of your current address. Examples are bank statement, credit card statement or utility bill.',
    //                         enabled: true,
    //                         label: 'Proof of Address',
    //                     },
    //                     proofOfId: {
    //                         content:
    //                             "Please upload a photo of one of your identity documents such as your Driver's Licence or National Identity Card in JPG format.",
    //                         enabled: true,
    //                         label: 'Proof of Identification',
    //                     },
    //                     proofOfInsurance: {
    //                         content:
    //                             'Please upload a document which has proof of you being insured for your declared amount.',
    //                         enabled: true,
    //                         label: 'Proof of Insurance',
    //                     },
    //                 },
    //                 enableMultiSiteLogin: {
    //                     enabled: false,
    //                 },
    //                 notification: {
    //                     content: null,
    //                     ctaButton: {
    //                         text: null,
    //                     },
    //                     enabled: false,
    //                 },
    //             },
    //             twilio: {
    //                 accountSid: '',
    //                 authToken: '',
    //                 enabled: false,
    //                 senderId: '',
    //             },
    //             useDescriptorTitle: false,
    //             useESignForInsuranceDocs: false,
    //             useWebRates: false,
    //             webhooks: {
    //                 docUpload: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 moveIn: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 pageLoad: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 reservation: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 reservationWithFee: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 leadFollowUp: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //             },
    //             directDebit: {
    //                 creditAmount: 0,
    //                 enabled: false,
    //             },
    //             requireAutobill: false,
    //             sendReservationEmailOnFeeFailure: false,
    //             allowSaveQuote: false,
    //             saveQuoteButtonText: 'Save My Quote',
    //             saveQuotePopupText: '',
    //             ccSiteEmailInSaveQuote: true,
    //             creditCardForAutobill: {
    //                 enabled: true,
    //             },
    //         },
    //         fees: {
    //             moveOutNotice: 2,
    //             lateDays: 3,
    //             lateFee: 20,
    //             adminFee: 20,
    //             nsfFee: 20,
    //             cleaningFee: 50,
    //             securityDeposit: 100,
    //         },
    //         changedAt: '2024-03-17T13:12:14.033Z',
    //         changeToken:
    //             '12091fbb6005b7d34a72778cecdd2b54cbcac2b3c23340a892ee50f0a7823305316b80f97c91a5e647ab675431d71659',
    //         deleted: false,
    //         DivisionID: '24',
    //         LanguageID: '1',
    //         OwnerID: '48',
    //         scaConfiguration: {},
    //         pdfFonts: {
    //             insuranceDocs: 'Arial',
    //             lease: 'Arial',
    //             receipt: 'Arial',
    //         },
    //         collections: {
    //             unitTypeGroup: {
    //                 name: 'unitTypeGroup',
    //                 job: 'CRAG/ASH/unitTypeGroup',
    //                 status: 'finished',
    //                 timestamp: 1710547699130,
    //             },
    //             inventory: {
    //                 name: 'inventory',
    //                 job: 'CRAG/ASH/inventory',
    //                 status: 'finished',
    //                 timestamp: 1710547699132,
    //             },
    //             paymentTypes: {
    //                 name: 'paymentTypes',
    //                 job: 'CRAG/ASH/paymentTypes',
    //                 status: 'finished',
    //                 timestamp: 1710547699133,
    //             },
    //             site: {
    //                 name: 'site',
    //                 job: 'CRAG/ASH/site',
    //                 status: 'finished',
    //                 timestamp: 1710547699132,
    //             },
    //             marketingSource: {
    //                 name: 'marketingSource',
    //                 job: 'CRAG/ASH/marketingSource',
    //                 status: 'finished',
    //                 timestamp: 1710547699133,
    //             },
    //             discountPlan: {
    //                 name: 'discountPlan',
    //                 job: 'CRAG/ASH/discountPlan',
    //                 status: 'finished',
    //                 timestamp: 1710547699133,
    //             },
    //             chargeDescription: {
    //                 name: 'chargeDescription',
    //                 job: 'CRAG/ASH/chargeDescription',
    //                 status: 'finished',
    //                 timestamp: 1710547699132,
    //             },
    //             insuranceCoverage: {
    //                 name: 'insuranceCoverage',
    //                 job: 'CRAG/ASH/insuranceCoverage',
    //                 status: 'finished',
    //                 timestamp: 1710547699133,
    //             },
    //             form: {
    //                 name: 'form',
    //                 job: 'CRAG/ASH/form',
    //                 status: 'finished',
    //                 timestamp: 1710547699133,
    //             },
    //             paymentSettings: {
    //                 name: 'paymentSettings',
    //                 job: 'CRAG/ASH/paymentSettings',
    //                 status: 'finished',
    //                 timestamp: 1710547699133,
    //             },
    //             unitsFull: {
    //                 name: 'unitsFull',
    //                 job: 'CRAG/ASH/unitsFull',
    //                 status: 'finished',
    //                 timestamp: 1710461195198,
    //             },
    //         },
    //         friendlyName: null,
    //         originalName: 'U-Store-It Keswick',
    //         personas: [
    //             {
    //                 _id: '65e69e4d7689a584c94d3546',
    //                 enabled: true,
    //                 name: 'Personal',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'personal',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //             {
    //                 _id: '65e69e4d7689a5b8154d3548',
    //                 enabled: true,
    //                 name: 'Vehicle',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'vehicle',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //             {
    //                 _id: '65e69e4d7689a5152e4d3547',
    //                 enabled: true,
    //                 name: 'Business',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'business',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //         ],
    //         sCorpCode: 'CRAG',
    //     },
    //     {
    //         SiteID: 32551,
    //         sLocationCode: 'BAR',
    //         sGlobalSiteNum: '32551',
    //         iMobileType: '0',
    //         iRegionalOptions: 1,
    //         iOnLineChargeType: '0',
    //         bFeatMobileStorage: 'false',
    //         iGMTTimeOffset: 10,
    //         sLocationDesc: null,
    //         sSiteIDCode: null,
    //         sSiteRegionCode: null,
    //         sContactName: 'Sally Keane',
    //         sEmailAddress: 'mtbarker@ustoreit.com.au',
    //         sSiteName: 'U-Store-It Mt Barker',
    //         sSiteAddr1: '7 Follett Close',
    //         sSiteAddr2: null,
    //         sSiteCity: 'Totness, Mt Barker',
    //         sSiteRegion: 'SA',
    //         sSitePostalCode: '5250',
    //         sSiteCountry: 'Australia',
    //         sSitePhone: '08 8120 1305',
    //         sSiteFAX: '.',
    //         sWebSiteURL: null,
    //         iFeatMaxUnits: '500',
    //         bFeatGate: 'true',
    //         bFeatKiosk: 'true',
    //         bFeatRevMgmt: 'true',
    //         bFeatCreditCards: 'true',
    //         bFeatCorpOffice: 'true',
    //         bFeatAccounting: 'true',
    //         bFeatRecordStorage: 'false',
    //         bFeatACH: 'true',
    //         dACHStatus: '2017-11-08T00:49:42.59-05:00',
    //         bLiteVersion: 'false',
    //         bTrial: 'false',
    //         bSubscription: 'false',
    //         bSiteDisabled: 'false',
    //         dGateUpdated: '2024-03-16T08:27:44.807-04:00',
    //         dOvernightProcess: '2024-03-17T10:17:06.04-04:00',
    //         sLegalName: 'U-Store-It Pty Ltd',
    //         bZipCodeData_Use: 'false',
    //         dcLongitude: '138.8472560000',
    //         dcLatitude: '-35.0541500000',
    //         bClosedWeekdays: 'false',
    //         bClosedSaturday: 'false',
    //         bClosedSunday: 'true',
    //         dWeekdayStrt: '2017-11-07T08:30:00-05:00',
    //         dWeekdayEnd: '2017-11-08T17:00:59-05:00',
    //         dSaturdayStrt: '2017-11-07T08:30:00-05:00',
    //         dSaturdayEnd: '2017-11-08T16:00:59-05:00',
    //         dSundayStrt: '2017-11-07T00:00:00-05:00',
    //         dSundayEnd: '2017-11-08T00:00:59-05:00',
    //         bPermanent: 'false',
    //         dUpdated: '2024-03-17T14:17:06.040Z',
    //         uTS: 'AAAAABxR4JA=',
    //         bFeatPromoAdvanced: 'false',
    //         iIdentifier: '0',
    //         sIdentifier: null,
    //         bUseInclusiveTaxation: true,
    //         bArchived: 'false',
    //         iBusinessType: '-999',
    //         iSiteDataType: '0',
    //         sTaxNumber: '53 659 430 120',
    //         iFacilityUsage: '0',
    //         iFacilityOwnership: '0',
    //         iFacilityMgmt: '0',
    //         iFacilityLocType: '0',
    //         iMobileBungoRules: '0',
    //         dCreated: '2017-11-07T08:45:31.703-05:00',
    //         iOnLinePmtsAllowed: '1',
    //         iEdition: '1',
    //         iTerminalServices: '0',
    //         iDST: '0',
    //         iVerboseLogging: '0',
    //         iSiteLinkStoreTier: '1',
    //         sSLBillingRef: 'RAGBAR',
    //         iSubscriptionType: '0',
    //         tWeekdayStrt: '08:30:00',
    //         tWeekdayEnd: '17:00:59',
    //         tSaturdayStrt: '08:30:00',
    //         tSaturdayEnd: '16:00:59',
    //         tSundayStrt: '00:00:00',
    //         tSundayEnd: '00:00:59',
    //         rapidstorEnabled: true,
    //         ownerId: '48',
    //         languageId: '1',
    //         divisionId: '24',
    //         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //         hours: {
    //             officeMondayOpen: '9:00am',
    //             officeTuesdayOpen: '9:00am',
    //             officeWednesdayOpen: '9:00am',
    //             officeThursdayOpen: '9:00am',
    //             officeFridayOpen: '9:00am',
    //             officeSaturdayOpen: '9:00am',
    //             officeSundayOpen: '9:00am',
    //             officeMondayClose: '5:00pm',
    //             officeTuesdayClose: '5:00pm',
    //             officeWednesdayClose: '5:00pm',
    //             officeThursdayClose: '5:00pm',
    //             officeFridayClose: '5:00pm',
    //             officeSaturdayClose: '5:00pm',
    //             officeSundayClose: '5:00pm',
    //             gateOpen: '9:00am',
    //             gateClose: '5:00pm',
    //             gateOpenWeekend: '9:00am',
    //             gateCloseWeekend: '5:00pm',
    //             gateCloseSaturday: '5:00pm',
    //             gateCloseSunday: '5:00pm',
    //             gateOpenSaturday: '9:00am',
    //             gateOpenSunday: '9:00am',
    //         },
    //         skin: {
    //             accentColours: {
    //                 primary: '#FFE700',
    //             },
    //             mainColour: '#ED1F15',
    //             highlightColour: '#CFD8DC',
    //             moveinTimeRemaining: false,
    //             defaultUnitPicture: 'https://ik.imagekit.io/bytcx9plm/3x3_f.png',
    //             themeColour: ''
    //         },
    //         administrative: {
    //             boxshopEnabled: true,
    //             testMode: false,
    //             rslite: false,
    //             rsliteKey: 'N/A',
    //             refreshEnabled: false,
    //             availableForUse: false,
    //             insuranceEnabled: false,
    //             merchEnabled: false,
    //             carouselListing: false,
    //             useMtasForAuth: false,
    //             featureAllowReservationsWhenNoAvailability: false,
    //             spacerIntegration: false,
    //             couponCloning: false
    //         },
    //         rapidstor: {
    //             pushRate: false,
    //             marketingSurvey: {
    //                 use: true,
    //                 questions: {
    //                     whereHearAboutUs: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     distanceFromFacility: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whyStoring: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     customerType: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whatStoring: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whyStoringWithUs: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                 },
    //             },
    //             country: 'AU',
    //             unitListing: {
    //                 sortOrder: {
    //                     primary: 'size',
    //                     secondary: 'price',
    //                     tertiary: 'availability',
    //                 },
    //                 useMultilevel: false,
    //             },
    //             siteLogo:
    //                 'https://ik.imagekit.io/bytcx9plm/CRAG-BAR-logo-cltf6fl7w000401pi9ful8zbu.png',
    //             allowOriginUrl: [],
    //             allowedCreditCardTypes: {
    //                 visa: true,
    //                 mastercard: true,
    //                 amex: true,
    //             },
    //             minAvailableUnits: 0,
    //             hideUnitsMinAvailable: true,
    //             noAvailableUnitsText: 'Call for Availability',
    //             hideQuickSearch: false,
    //             smallMediumSize: 7,
    //             mediumLargeSize: 13,
    //             moveinHideAcp: false,
    //             insuranceRequired: false,
    //             hideBoxshop: false,
    //             hideInsurance: false,
    //             hideLicense: false,
    //             hideLicenseState: true,
    //             hideDateOfBirth: true,
    //             hideState: false,
    //             hidePostalCode: false,
    //             autoOptInSms: false,
    //             currencySymbol: '$',
    //             sizeSymbol: 'm',
    //             groundFloor: 0,
    //             billingDefault: 'MonthlyAnniversary',
    //             shippingEnabled: false,
    //             legacyPickupLocationsEnabled: false,
    //             legacyPickupLocations: null,
    //             shippingInventoryItem: null,
    //             freeShippingDealEnabled: false,
    //             freeShippingDealAmount: 150,
    //             allowReservation: true,
    //             allowMoveIn: true,
    //             reservationNumberOfDaysInAdvanceLimit: 30,
    //             moveinNumberOfDaysInAdvanceLimit: 7,
    //             reservationNumberOfDaysInAdvanceChargeFee: 365,
    //             assistanceMoving: false,
    //             assistanceMovingEmailAddress: '',
    //             notificationsFromAddress: '',
    //             completeMoveinUrl: '',
    //             useESign: false,
    //             useAutoBilling: true,
    //             autoBillCheckedByDefault: false,
    //             doNotSendInvoiceSiteLinkWhenAutoBill: false,
    //             areaSizeSymbol: 'm²',
    //             allowReservationsWhenNoAvailability: false,
    //             attachInsuranceDocsToMoveInConfirmationEmail: false,
    //             attachLeaseToMoveInConfirmationEmail: true,
    //             attachReceiptToMoveInConfirmationEmail: true,
    //             autoESignRedirect: false,
    //             autoOptInSMS: false,
    //             bookOnlineDiscount: 0,
    //             boxshopCategoryAlphaOrder: false,
    //             boxshopPurchaseAttachmentName: '',
    //             boxshopPurchaseEmailSubject: '',
    //             boxshopTermsConditions: '',
    //             checkForExistingTenant: false,
    //             completeMoveinURL: '',
    //             currency: 'AUD',
    //             dateFormat: 'yyyy-MM-dd',
    //             datesClosed: '',
    //             delayedInsurance: {
    //                 enabled: false,
    //                 timings: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //             },
    //             directDebit: {
    //                 creditAmount: 0,
    //                 enabled: false,
    //             },
    //             documentVerification: {
    //                 enabled: false,
    //                 providerToUse: null,
    //                 providers: {
    //                     rapidId: {
    //                         label: 'RapidID',
    //                         token: null,
    //                     },
    //                 },
    //             },
    //             eSignInsuranceForm: {
    //                 sFormName: null,
    //             },
    //             eSignInsuranceFormName: '',
    //             eSignMoveInDocumentNames: [],
    //             eSignMoveInDocuments: [],
    //             eSignReturnUrl: '',
    //             emailSchedules: {
    //                 quoteUnlockFirstReminder: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //                 quoteUnlockSecondReminder: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //                 reservationNotMovedIn: {
    //                     days: null,
    //                     hours: null,
    //                     mintues: null,
    //                 },
    //                 quoteEmail: {
    //                     '1': {
    //                         subject: null,
    //                     },
    //                     '2': {
    //                         days: null,
    //                         hours: null,
    //                         minutes: null,
    //                         subject: null,
    //                     },
    //                     '3': {
    //                         days: null,
    //                         hours: null,
    //                         minutes: null,
    //                         subject: null,
    //                     },
    //                 },
    //             },
    //             enquiryAPI: {
    //                 numOptions: 3,
    //             },
    //             facilitySelfService: {
    //                 boxshop: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-boxshop.png',
    //                 },
    //                 enquiries: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-enquiries.png',
    //                 },
    //                 moveOut: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-moveout.png',
    //                 },
    //                 takePayment: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-take-payment.png',
    //                 },
    //             },
    //             features: {
    //                 boxshop: 'standard',
    //                 'carousel-unit-listing': 'standard',
    //                 'facility-self-service': 'standard',
    //                 'facility-staff-self-service': 'standard',
    //                 'movein-wizard': 'single-page',
    //                 'reservation-with-fee-wizard': 'standard',
    //                 'tenant-accounts': 'standard',
    //                 'tiered-unit-listing': 'standard',
    //                 'unit-listing': 'standard',
    //             },
    //             forceTaxInclusive: false,
    //             hidePrices: false,
    //             includeFutureMoveOut: false,
    //             includeReservedUnitsInOccupied: true,
    //             insuranceCustomFormat: '',
    //             insuranceEsignReturnUrl: '',
    //             insurancePolicyNumberRange: {
    //                 end: null,
    //                 start: null,
    //             },
    //             insurancePolicyNumberRefreshNum: null,
    //             insuranceSmsFollowUpContent: '',
    //             kioskUnitListing: 'standard',
    //             language: {
    //                 selectionOption: 'auto-detect',
    //             },
    //             locationPageUrl: '',
    //             moveinEmailSubject: '',
    //             moveinHideACP: false,
    //             moveinRedirectUrl: '',
    //             notificationsAdditionalBCCAddresses: [],
    //             notificationsAdditionalCCAddresses: [],
    //             notificationsFromName: '',
    //             notificationsReplyAddress: '',
    //             payLaterButtonText: 'Pay Later',
    //             payNowButtonText: 'Pay Now',
    //             paymentGateways: {
    //                 bypassSitelinkProcessing: false,
    //                 gatewayToUse: '',
    //                 paygate: {
    //                     countryCode: '',
    //                     currency: '',
    //                     encryptionKey: '',
    //                     locale: '',
    //                     payMethod: '',
    //                     paygateId: '',
    //                 },
    //                 paynamics: {
    //                     countryCode: 'PH',
    //                     currency: '',
    //                     merchantId: '',
    //                     merchantKey: '',
    //                     merchantTermsUrl: '',
    //                     paymentMethods: ['bn', 'cc', 'dp', 'gc', 'pp'],
    //                     secure3d: 'try3d',
    //                 },
    //                 paypal: {
    //                     clientId: '',
    //                     clientSecret: '',
    //                     currency: '',
    //                     useTestEnv: false,
    //                     force3dsCheck: false,
    //                 },
    //                 paytabs: {
    //                     countryCode: '',
    //                     merchantEmail: '',
    //                     merchantId: '',
    //                     merchantSiteUrl: '',
    //                     messageLanguage: '',
    //                     secretKey: '',
    //                     currency: ''
    //                 },
    //                 use: false,
    //                 r6Pay: {
    //                     currency: '',
    //                     useTestEnv: false,
    //                 },
    //             },
    //             pickupEnabled: true,
    //             quickReserveButtonText: 'Quick Reserve',
    //             recaptcha: {
    //                 enabled: false,
    //                 secretKey: '',
    //                 siteKey: '',
    //                 tolerance: 0.5,
    //             },
    //             requireAutobill: false,
    //             reservationEmailSubject: '',
    //             reservationExpireOccupancyValues: {
    //                 bands: [
    //                     {
    //                         days: 30,
    //                         from: 0,
    //                         to: 100,
    //                     },
    //                 ],
    //                 enabled: false,
    //             },
    //             reservationExpireReservationDays: 30,
    //             reservationPopupText: '',
    //             resetPasswordUrl: '',
    //             scheduleFollowUpEmails: false,
    //             sendReservationEmailOnFeeFailure: false,
    //             showAreaInsteadOfDimensions: false,
    //             showAutobillTerms: false,
    //             showMoveInDateLimitMessage: false,
    //             showPricesButtonText: 'Show Prices',
    //             showPricesShowNeeded: true,
    //             showVehicleQuickSearch: false,
    //             showWeeklyRates: false,
    //             siteLinkLeaseFields: [],
    //             siteOpeningDate: null,
    //             sitelinkCostRetrieveChargeNameSubstiutions: [],
    //             spaceCalculatorValues: {
    //                 bedroom: 4,
    //                 box: 0.05,
    //                 garage: 7,
    //                 highestValue: {
    //                     area: 20,
    //                     high: 30,
    //                     low: 18,
    //                 },
    //                 largeItem: 1.5,
    //                 largeRoom: 5,
    //                 lowestValue: {
    //                     area: 3,
    //                     high: 5,
    //                     low: 1,
    //                 },
    //                 room: 4,
    //                 smallItem: 0.5,
    //                 smallRoom: 3,
    //             },
    //             tenantAccounts: {
    //                 autoPayment: {
    //                     enabled: true,
    //                 },
    //                 enableMultiSiteLogin: {
    //                     enabled: false,
    //                 },
    //                 invoiceHistory: {
    //                     enabled: true,
    //                     showChargeBatch: false
    //                 },
    //                 makePayment: {
    //                     enabled: true,
    //                 },
    //                 notification: {
    //                     content: null,
    //                     ctaButton: {
    //                         text: null,
    //                     },
    //                     enabled: false,
    //                 },
    //                 paymentHistory: {
    //                     enabled: true,
    //                 },
    //                 tenantInfo: {
    //                     enabled: true,
    //                 },
    //                 uploadDocuments: {
    //                     enabled: true,
    //                     generalContent:
    //                         'Please select & upload the following documents as a pdf or image.',
    //                     proofOfAddress: {
    //                         content:
    //                             'Please upload a photo which has proof of your current address. Examples are bank statement, credit card statement or utility bill.',
    //                         enabled: true,
    //                         label: 'Proof of Address',
    //                     },
    //                     proofOfId: {
    //                         content:
    //                             "Please upload a photo of one of your identity documents such as your Driver's Licence or National Identity Card in JPG format.",
    //                         enabled: true,
    //                         label: 'Proof of Identification',
    //                     },
    //                     proofOfInsurance: {
    //                         content:
    //                             'Please upload a document which has proof of you being insured for your declared amount.',
    //                         enabled: true,
    //                         label: 'Proof of Insurance',
    //                     },
    //                 },
    //             },
    //             tieredPricing: {
    //                 cherryPickBasis: 'lowestRate',
    //                 hidePrices: false,
    //                 hideQuickSearch: false,
    //                 noAvailableUnitsText: 'Call for Availability',
    //                 showAvailableUnitsCount: false,
    //                 showPricesShowNeeded: true,
    //                 showTiersWithNoAvailableUnits: true,
    //                 showVehicleQuickSearch: false,
    //                 noAvailableUnitsSecondaryAction: '',
    //                 noAvailableUnitsSecondaryText: ''
    //             },
    //             twilio: {
    //                 accountSid: '',
    //                 authToken: '',
    //                 enabled: false,
    //                 senderId: '',
    //             },
    //             useBoxShopCoupons: false,
    //             useDealCoupons: false,
    //             useDescriptorTitle: false,
    //             useESignForInsuranceDocs: false,
    //             useWebRates: false,
    //             webhooks: {
    //                 docUpload: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 moveIn: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 pageLoad: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 reservation: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 reservationWithFee: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 leadFollowUp: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //             },
    //             wizards: {
    //                 moveinSingle: {
    //                     allowIdUpload: false,
    //                     allowProofOfAddressUpload: false,
    //                     allowProofOfInsuranceUpload: false,
    //                     hideAlternativeContact: true,
    //                     hideBoxshop: false,
    //                     hideDateOfBirth: true,
    //                     hideDriversLicence: false,
    //                     hideDriversLicenceState: true,
    //                     hideInsurance: false,
    //                     hideInsurancePicker: false,
    //                     hidePostalCode: false,
    //                     hideState: false,
    //                     insuranceAcceptancePopoverText: '',
    //                     insuranceAcceptanceText: 'By ticking this box you accept and agree; that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C’s below and understand the inclusions/exclusions of the policy.',
    //                     insuranceContent: '',
    //                     insuranceContentPopoverText: '',
    //                     insuranceManualEntry: false,
    //                     insuranceManualEntryRequired: false,
    //                     insuranceRefusedPopoverText: '',
    //                     insuranceRefusedText: 'By ticking this box, you are choosing not to be covered by insurance and acknowledge that we will not be held responsible for any damaged or lost goods during your rental period.',
    //                     insuranceRequired: false,
    //                     requireAlternativeContactPhoneNumberField: true,
    //                     hideDriversLicence_state: false,
    //                     allowSelfInsurance: false,
    //                     hide_postalCode: false,
    //                     distinguishCustomerTypes: false
    //                 },
    //                 moveinStandard: {
    //                     requireAlternativeContactPhoneNumberField: true,
    //                 },
    //                 reservationWithFeeStandard: {},
    //             },
    //             allowSaveQuote: false,
    //             saveQuoteButtonText: 'Save My Quote',
    //             saveQuotePopupText: '',
    //             ccSiteEmailInSaveQuote: true,
    //             creditCardForAutobill: {
    //                 enabled: true,
    //             },
    //         },
    //         fees: {
    //             moveOutNotice: 2,
    //             lateDays: 3,
    //             lateFee: 20,
    //             adminFee: 20,
    //             nsfFee: 20,
    //             cleaningFee: 50,
    //             securityDeposit: 100,
    //         },
    //         OwnerID: '48',
    //         LanguageID: '1',
    //         DivisionID: '24',
    //         bForcePushRates: '0',
    //         iWebRatesType: '0',
    //         collections: {
    //             unitsFull: {
    //                 name: 'unitsFull',
    //                 job: 'CRAG/BAR/unitsFull',
    //                 status: 'finished',
    //                 timestamp: 1710547699133,
    //             },
    //             unitTypeGroup: {
    //                 name: 'unitTypeGroup',
    //                 job: 'CRAG/BAR/unitTypeGroup',
    //                 status: 'finished',
    //                 timestamp: 1710547699133,
    //             },
    //             paymentTypes: {
    //                 name: 'paymentTypes',
    //                 job: 'CRAG/BAR/paymentTypes',
    //                 status: 'finished',
    //                 timestamp: 1710547699135,
    //             },
    //             inventory: {
    //                 name: 'inventory',
    //                 job: 'CRAG/BAR/inventory',
    //                 status: 'finished',
    //                 timestamp: 1710547699135,
    //             },
    //             form: {
    //                 name: 'form',
    //                 job: 'CRAG/BAR/form',
    //                 status: 'finished',
    //                 timestamp: 1710547699135,
    //             },
    //             marketingSource: {
    //                 name: 'marketingSource',
    //                 job: 'CRAG/BAR/marketingSource',
    //                 status: 'finished',
    //                 timestamp: 1710547699135,
    //             },
    //             paymentSettings: {
    //                 name: 'paymentSettings',
    //                 job: 'CRAG/BAR/paymentSettings',
    //                 status: 'finished',
    //                 timestamp: 1710547699135,
    //             },
    //             site: {
    //                 name: 'site',
    //                 job: 'CRAG/BAR/site',
    //                 status: 'finished',
    //                 timestamp: 1710547699134,
    //             },
    //             chargeDescription: {
    //                 name: 'chargeDescription',
    //                 job: 'CRAG/BAR/chargeDescription',
    //                 status: 'finished',
    //                 timestamp: 1710547699135,
    //             },
    //             insuranceCoverage: {
    //                 name: 'insuranceCoverage',
    //                 job: 'CRAG/BAR/insuranceCoverage',
    //                 status: 'finished',
    //                 timestamp: 1710461195202,
    //             },
    //             discountPlan: {
    //                 name: 'discountPlan',
    //                 job: 'CRAG/BAR/discountPlan',
    //                 status: 'finished',
    //                 timestamp: 1710461195202,
    //             },
    //         },
    //         changeToken:
    //             '54415e808a98a46db0333b806626c68b209a3849862e101d4acda5d374e3b5f95382c8ade6e9e7e7780894d90dae0916',
    //         changedAt: '2024-03-17T18:34:29.172Z',
    //         deleted: false,
    //         friendlyName: null,
    //         originalName: 'U-Store-It Mt Barker',
    //         pdfFonts: {
    //             insuranceDocs: 'Arial',
    //             lease: 'Arial',
    //             receipt: 'Arial',
    //         },
    //         scaConfiguration: {},
    //         personas: [
    //             {
    //                 _id: '65e69e4d7689a584c94d3546',
    //                 enabled: true,
    //                 name: 'Personal',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'personal',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //             {
    //                 _id: '65e69e4d7689a5b8154d3548',
    //                 enabled: true,
    //                 name: 'Vehicle',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'vehicle',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //             {
    //                 _id: '65e69e4d7689a5152e4d3547',
    //                 enabled: true,
    //                 name: 'Business',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'business',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //         ],
    //         sCorpCode: 'CRAG',
    //     },
    //     {
    //         SiteID: 1803,
    //         sLocationCode: 'GEP',
    //         sGlobalSiteNum: '14511',
    //         iMobileType: '0',
    //         iRegionalOptions: 1,
    //         iOnLineChargeType: '0',
    //         bFeatMobileStorage: 'false',
    //         iGMTTimeOffset: 10,
    //         sLocationDesc: null,
    //         sSiteIDCode: null,
    //         sSiteRegionCode: null,
    //         sContactName: 'Silvia DÁrrigo',
    //         sEmailAddress: 'geppscross@ustoreit.com.au',
    //         sSiteName: 'U-Store-It Gepps Cross',
    //         sSiteAddr1: '575 Grand Junction Road',
    //         sSiteAddr2: null,
    //         sSiteCity: 'Gepps Cross',
    //         sSiteRegion: 'SA',
    //         sSitePostalCode: '5094',
    //         sSiteCountry: 'AUS',
    //         sSitePhone: '08 8262 5593',
    //         sSiteFAX: '.',
    //         sWebSiteURL: null,
    //         iFeatMaxUnits: '750',
    //         bFeatGate: 'true',
    //         bFeatKiosk: 'true',
    //         bFeatRevMgmt: 'true',
    //         bFeatCreditCards: 'true',
    //         bFeatCorpOffice: 'true',
    //         bFeatAccounting: 'true',
    //         bFeatRecordStorage: 'false',
    //         bFeatACH: 'true',
    //         dACHStatus: '2010-11-02T12:01:07.693-04:00',
    //         bLiteVersion: 'false',
    //         bTrial: 'false',
    //         bSubscription: 'false',
    //         bSiteDisabled: 'false',
    //         dGateUpdated: '2024-03-08T08:46:47.073-05:00',
    //         dOvernightProcess: '2024-03-17T10:08:01.03-04:00',
    //         sLegalName: 'U-Store-It Pty Ltd',
    //         bZipCodeData_Use: 'false',
    //         dcLongitude: '138.5852670000',
    //         dcLatitude: '-34.8476480000',
    //         bClosedWeekdays: 'false',
    //         bClosedSaturday: 'false',
    //         bClosedSunday: 'true',
    //         dWeekdayStrt: '2010-05-31T08:30:00-04:00',
    //         dWeekdayEnd: '2010-05-31T17:00:59-04:00',
    //         dSaturdayStrt: '2010-05-31T08:30:00-04:00',
    //         dSaturdayEnd: '2010-05-31T16:00:59-04:00',
    //         dSundayStrt: '2010-05-31T00:00:00-04:00',
    //         dSundayEnd: '2010-05-31T00:00:59-04:00',
    //         bPermanent: 'false',
    //         dUpdated: '2024-03-17T14:08:01.030Z',
    //         uTS: 'AAAAABxRYVc=',
    //         bFeatPromoAdvanced: 'false',
    //         iIdentifier: '0',
    //         sIdentifier: null,
    //         bUseInclusiveTaxation: true,
    //         bArchived: 'false',
    //         iBusinessType: '0',
    //         iSiteDataType: '0',
    //         sTaxNumber: '53 659 430 120',
    //         iFacilityUsage: '0',
    //         iFacilityOwnership: '0',
    //         iFacilityMgmt: '0',
    //         iFacilityLocType: '0',
    //         iMobileBungoRules: '0',
    //         dCreated: '2010-05-28T00:00:00-04:00',
    //         iOnLinePmtsAllowed: '1',
    //         iEdition: '1',
    //         iTerminalServices: '0',
    //         iDST: '0',
    //         iVerboseLogging: '0',
    //         iSiteLinkStoreTier: '1',
    //         sSLBillingRef: 'RAGGEP',
    //         iSubscriptionType: '0',
    //         tWeekdayStrt: '08:30:00',
    //         tWeekdayEnd: '17:00:59',
    //         tSaturdayStrt: '08:30:00',
    //         tSaturdayEnd: '16:00:59',
    //         tSundayStrt: '00:00:00',
    //         tSundayEnd: '00:00:59',
    //         rapidstorEnabled: true,
    //         bForcePushRates: '0',
    //         iWebRatesType: '0',
    //         ownerId: '48',
    //         languageId: '1',
    //         divisionId: '24',
    //         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //         hours: {
    //             officeMondayOpen: '9:00am',
    //             officeTuesdayOpen: '9:00am',
    //             officeWednesdayOpen: '9:00am',
    //             officeThursdayOpen: '9:00am',
    //             officeFridayOpen: '9:00am',
    //             officeSaturdayOpen: '9:00am',
    //             officeSundayOpen: '9:00am',
    //             officeMondayClose: '5:00pm',
    //             officeTuesdayClose: '5:00pm',
    //             officeWednesdayClose: '5:00pm',
    //             officeThursdayClose: '5:00pm',
    //             officeFridayClose: '5:00pm',
    //             officeSaturdayClose: '5:00pm',
    //             officeSundayClose: '5:00pm',
    //             gateOpen: '9:00am',
    //             gateClose: '5:00pm',
    //             gateOpenWeekend: '9:00am',
    //             gateCloseWeekend: '5:00pm',
    //             gateCloseSaturday: '5:00pm',
    //             gateCloseSunday: '5:00pm',
    //             gateOpenSaturday: '9:00am',
    //             gateOpenSunday: '9:00am',
    //         },
    //         skin: {
    //             accentColours: {
    //                 primary: '#FFE700',
    //             },
    //             defaultUnitPicture: 'https://ik.imagekit.io/bytcx9plm/3x3_f.png',
    //             mainColour: '#ED1F15',
    //             highlightColour: '#CFD8DC',
    //             moveinTimeRemaining: false,
    //             themeColour: ''
    //         },
    //         administrative: {
    //             boxshopEnabled: true,
    //             testMode: false,
    //             rslite: false,
    //             rsliteKey: 'N/A',
    //             refreshEnabled: false,
    //             availableForUse: false,
    //             insuranceEnabled: false,
    //             merchEnabled: false,
    //             carouselListing: false,
    //             useMtasForAuth: false,
    //             featureAllowReservationsWhenNoAvailability: false,
    //             spacerIntegration: false,
    //             couponCloning: false
    //         },
    //         rapidstor: {
    //             pushRate: false,
    //             marketingSurvey: {
    //                 use: true,
    //                 questions: {
    //                     whereHearAboutUs: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     distanceFromFacility: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whyStoring: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     customerType: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whatStoring: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whyStoringWithUs: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                 },
    //             },
    //             country: 'AU',
    //             unitListing: {
    //                 sortOrder: {
    //                     primary: 'size',
    //                     secondary: 'price',
    //                     tertiary: 'availability',
    //                 },
    //                 useMultilevel: false,
    //             },
    //             siteLogo:
    //                 'https://ik.imagekit.io/bytcx9plm/CRAG-GEP-logo-cjrvic1py0008f9mofkn5e4dp.png',
    //             allowOriginUrl: [],
    //             allowedCreditCardTypes: {
    //                 visa: true,
    //                 mastercard: true,
    //                 amex: true,
    //             },
    //             facilitySelfService: {
    //                 enquiries: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-enquiries.png',
    //                 },
    //                 takePayment: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-take-payment.png',
    //                 },
    //                 moveOut: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-moveout.png',
    //                 },
    //                 boxshop: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-boxshop.png',
    //                 },
    //             },
    //             tieredPricing: {
    //                 showTiersWithNoAvailableUnits: true,
    //                 noAvailableUnitsText: 'Call for Availability',
    //                 cherryPickBasis: 'lowestRate',
    //                 hidePrices: false,
    //                 hideQuickSearch: false,
    //                 showAvailableUnitsCount: false,
    //                 showPricesShowNeeded: true,
    //                 showVehicleQuickSearch: false,
    //                 noAvailableUnitsSecondaryAction: '',
    //                 noAvailableUnitsSecondaryText: ''
    //             },
    //             minAvailableUnits: 0,
    //             hideUnitsMinAvailable: false,
    //             noAvailableUnitsText: 'Call for Availability',
    //             hideQuickSearch: false,
    //             smallMediumSize: 6,
    //             mediumLargeSize: 10,
    //             moveinHideAcp: false,
    //             insuranceRequired: false,
    //             hideBoxshop: false,
    //             hideInsurance: false,
    //             hideLicense: false,
    //             hideLicenseState: true,
    //             hideDateOfBirth: true,
    //             hideState: false,
    //             hidePostalCode: false,
    //             autoOptInSms: false,
    //             currencySymbol: '$',
    //             sizeSymbol: 'm',
    //             groundFloor: 0,
    //             billingDefault: 'MonthlyAnniversary',
    //             shippingEnabled: false,
    //             legacyPickupLocationsEnabled: false,
    //             legacyPickupLocations: null,
    //             shippingInventoryItem: null,
    //             freeShippingDealEnabled: false,
    //             freeShippingDealAmount: 150,
    //             allowReservation: true,
    //             allowMoveIn: true,
    //             reservationNumberOfDaysInAdvanceLimit: 30,
    //             moveinNumberOfDaysInAdvanceLimit: 7,
    //             reservationNumberOfDaysInAdvanceChargeFee: 365,
    //             assistanceMoving: false,
    //             assistanceMovingEmailAddress: '',
    //             notificationsFromAddress: '',
    //             completeMoveinUrl: '',
    //             useESign: false,
    //             useAutoBilling: true,
    //             autoBillCheckedByDefault: false,
    //             doNotSendInvoiceSiteLinkWhenAutoBill: false,
    //             quickReserveButtonText: 'Quick Reserve',
    //             reservationExpireReservationDays: 30,
    //             areaSizeSymbol: 'm²',
    //             allowReservationsWhenNoAvailability: false,
    //             attachLeaseToMoveInConfirmationEmail: true,
    //             attachReceiptToMoveInConfirmationEmail: true,
    //             autoESignRedirect: false,
    //             autoOptInSMS: false,
    //             bookOnlineDiscount: 0,
    //             boxshopCategoryAlphaOrder: false,
    //             boxshopPurchaseAttachmentName: '',
    //             boxshopPurchaseEmailSubject: '',
    //             boxshopTermsConditions: '',
    //             checkForExistingTenant: false,
    //             completeMoveinURL: '',
    //             currency: 'AUD',
    //             dateFormat: 'yyyy-MM-dd',
    //             datesClosed: '',
    //             eSignInsuranceFormName: '',
    //             eSignMoveInDocumentNames: [],
    //             eSignMoveInDocuments: [],
    //             eSignReturnUrl: '',
    //             enquiryAPI: {
    //                 numOptions: 3,
    //             },
    //             features: {
    //                 boxshop: 'standard',
    //                 'carousel-unit-listing': 'standard',
    //                 'facility-self-service': 'standard',
    //                 'facility-staff-self-service': 'standard',
    //                 'movein-wizard': 'single-page',
    //                 'reservation-with-fee-wizard': 'standard',
    //                 'tenant-accounts': 'standard',
    //                 'tiered-unit-listing': 'standard',
    //                 'unit-listing': 'standard',
    //             },
    //             forceTaxInclusive: false,
    //             hidePrices: false,
    //             includeFutureMoveOut: false,
    //             includeReservedUnitsInOccupied: true,
    //             insuranceCustomFormat: '',
    //             insuranceEsignReturnUrl: '',
    //             language: {
    //                 selectionOption: 'auto-detect',
    //             },
    //             locationPageUrl: '',
    //             moveinEmailSubject: '',
    //             moveinHideACP: false,
    //             moveinRedirectUrl: '',
    //             notificationsAdditionalBCCAddresses: [],
    //             notificationsAdditionalCCAddresses: [],
    //             notificationsReplyAddress: '',
    //             payLaterButtonText: 'Pay Later',
    //             payNowButtonText: 'Pay Now',
    //             paymentGateways: {
    //                 bypassSitelinkProcessing: false,
    //                 gatewayToUse: '',
    //                 paygate: {
    //                     countryCode: '',
    //                     currency: '',
    //                     encryptionKey: '',
    //                     locale: '',
    //                     payMethod: '',
    //                     paygateId: '',
    //                 },
    //                 paynamics: {
    //                     countryCode: 'PH',
    //                     currency: '',
    //                     merchantId: '',
    //                     merchantKey: '',
    //                     merchantTermsUrl: '',
    //                     paymentMethods: ['cc', 'bn', 'gc', 'pp', 'dp'],
    //                     secure3d: 'try3d',
    //                 },
    //                 paypal: {
    //                     clientId: '',
    //                     clientSecret: '',
    //                     currency: '',
    //                     useTestEnv: false,
    //                     force3dsCheck: false,
    //                 },
    //                 paytabs: {
    //                     countryCode: '',
    //                     merchantEmail: '',
    //                     merchantId: '',
    //                     merchantSiteUrl: '',
    //                     messageLanguage: '',
    //                     secretKey: '',
    //                     currency: ''
    //                 },
    //                 use: false,
    //                 r6Pay: {
    //                     currency: '',
    //                     useTestEnv: false,
    //                 },
    //             },
    //             pickupEnabled: true,
    //             recaptcha: {
    //                 enabled: false,
    //                 secretKey: '',
    //                 siteKey: '',
    //                 tolerance: 0.5,
    //             },
    //             reservationEmailSubject: '',
    //             reservationExpireOccupancyValues: {
    //                 bands: [
    //                     {
    //                         from: 0,
    //                         to: 100,
    //                         days: 30,
    //                     },
    //                 ],
    //                 enabled: false,
    //             },
    //             reservationPopupText: '',
    //             resetPasswordUrl: '',
    //             scheduleFollowUpEmails: false,
    //             showAreaInsteadOfDimensions: false,
    //             showAutobillTerms: false,
    //             showMoveInDateLimitMessage: false,
    //             showPricesButtonText: 'Show Prices',
    //             showPricesShowNeeded: true,
    //             showVehicleQuickSearch: false,
    //             showWeeklyRates: false,
    //             siteLinkLeaseFields: [],
    //             sitelinkCostRetrieveChargeNameSubstiutions: [],
    //             spaceCalculatorValues: {
    //                 bedroom: 4,
    //                 box: 0.05,
    //                 garage: 7,
    //                 highestValue: {
    //                     area: 20,
    //                     high: 30,
    //                     low: 18,
    //                 },
    //                 largeItem: 1.5,
    //                 largeRoom: 5,
    //                 lowestValue: {
    //                     area: 3,
    //                     high: 5,
    //                     low: 1,
    //                 },
    //                 room: 4,
    //                 smallItem: 0.5,
    //                 smallRoom: 3,
    //             },
    //             tenantAccounts: {
    //                 autoPayment: {
    //                     enabled: true,
    //                 },
    //                 invoiceHistory: {
    //                     enabled: true,
    //                     showChargeBatch: false
    //                 },
    //                 makePayment: {
    //                     enabled: true,
    //                 },
    //                 paymentHistory: {
    //                     enabled: true,
    //                 },
    //                 tenantInfo: {
    //                     enabled: true,
    //                 },
    //                 uploadDocuments: {
    //                     enabled: true,
    //                     generalContent:
    //                         'Please select & upload the following documents as a pdf or image.',
    //                     proofOfAddress: {
    //                         content:
    //                             'Please upload a photo which has proof of your current address. Examples are bank statement, credit card statement or utility bill.',
    //                         enabled: true,
    //                         label: 'Proof of Address',
    //                     },
    //                     proofOfId: {
    //                         content:
    //                             "Please upload a photo of one of your identity documents such as your Driver's Licence or National Identity Card in JPG format.",
    //                         enabled: true,
    //                         label: 'Proof of Identification',
    //                     },
    //                     proofOfInsurance: {
    //                         content:
    //                             'Please upload a document which has proof of you being insured for your declared amount.',
    //                         enabled: true,
    //                         label: 'Proof of Insurance',
    //                     },
    //                 },
    //                 enableMultiSiteLogin: {
    //                     enabled: false,
    //                 },
    //                 notification: {
    //                     content: null,
    //                     ctaButton: {
    //                         text: null,
    //                     },
    //                     enabled: false,
    //                 },
    //             },
    //             useBoxShopCoupons: false,
    //             useDealCoupons: false,
    //             useDescriptorTitle: false,
    //             useESignForInsuranceDocs: false,
    //             useWebRates: false,
    //             webhooks: {
    //                 docUpload: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 moveIn: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 pageLoad: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 reservation: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 reservationWithFee: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 leadFollowUp: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //             },
    //             wizards: {
    //                 moveinSingle: {
    //                     allowIdUpload: false,
    //                     allowProofOfAddressUpload: false,
    //                     allowProofOfInsuranceUpload: false,
    //                     hideAlternativeContact: true,
    //                     hideBoxshop: false,
    //                     hideDateOfBirth: true,
    //                     hideDriversLicence: false,
    //                     hideDriversLicenceState: true,
    //                     hideInsurance: false,
    //                     hideInsurancePicker: false,
    //                     hidePostalCode: false,
    //                     hideState: false,
    //                     insuranceAcceptancePopoverText: '',
    //                     insuranceAcceptanceText: 'By ticking this box you accept and agree; that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C’s below and understand the inclusions/exclusions of the policy.',
    //                     insuranceContent: '',
    //                     insuranceContentPopoverText: '',
    //                     insuranceManualEntry: false,
    //                     insuranceManualEntryRequired: false,
    //                     insuranceRefusedPopoverText: '',
    //                     insuranceRefusedText: 'By ticking this box, you are choosing not to be covered by insurance and acknowledge that we will not be held responsible for any damaged or lost goods during your rental period.',
    //                     insuranceRequired: false,
    //                     requireAlternativeContactPhoneNumberField: true,
    //                     hideDriversLicence_state: false,
    //                     allowSelfInsurance: false,
    //                     hide_postalCode: false,
    //                     distinguishCustomerTypes: false
    //                 },
    //                 moveinStandard: {
    //                     requireAlternativeContactPhoneNumberField: true,
    //                 },
    //                 reservationWithFeeStandard: {},
    //             },
    //             attachInsuranceDocsToMoveInConfirmationEmail: false,
    //             delayedInsurance: {
    //                 enabled: false,
    //                 timings: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //             },
    //             documentVerification: {
    //                 enabled: false,
    //                 providerToUse: null,
    //                 providers: {
    //                     rapidId: {
    //                         label: 'RapidID',
    //                         token: null,
    //                     },
    //                 },
    //             },
    //             eSignInsuranceForm: {
    //                 sFormName: null,
    //             },
    //             emailSchedules: {
    //                 quoteUnlockFirstReminder: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //                 quoteUnlockSecondReminder: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //                 reservationNotMovedIn: {
    //                     days: null,
    //                     hours: null,
    //                     mintues: null,
    //                 },
    //                 quoteEmail: {
    //                     '1': {
    //                         subject: null,
    //                     },
    //                     '2': {
    //                         days: null,
    //                         hours: null,
    //                         minutes: null,
    //                         subject: null,
    //                     },
    //                     '3': {
    //                         days: null,
    //                         hours: null,
    //                         minutes: null,
    //                         subject: null,
    //                     },
    //                 },
    //             },
    //             insurancePolicyNumberRange: {
    //                 end: null,
    //                 start: null,
    //             },
    //             insurancePolicyNumberRefreshNum: null,
    //             insuranceSmsFollowUpContent: '',
    //             kioskUnitListing: 'standard',
    //             notificationsFromName: '',
    //             siteOpeningDate: null,
    //             twilio: {
    //                 accountSid: '',
    //                 authToken: '',
    //                 enabled: false,
    //                 senderId: '',
    //             },
    //             directDebit: {
    //                 creditAmount: 0,
    //                 enabled: false,
    //             },
    //             requireAutobill: false,
    //             sendReservationEmailOnFeeFailure: false,
    //             allowSaveQuote: false,
    //             saveQuoteButtonText: 'Save My Quote',
    //             saveQuotePopupText: '',
    //             ccSiteEmailInSaveQuote: true,
    //             creditCardForAutobill: {
    //                 enabled: true,
    //             },
    //         },
    //         fees: {
    //             moveOutNotice: 2,
    //             lateDays: 3,
    //             lateFee: 20,
    //             adminFee: 20,
    //             nsfFee: 20,
    //             cleaningFee: 50,
    //             securityDeposit: 100,
    //         },
    //         changedAt: '2024-03-17T16:31:44.508Z',
    //         changeToken:
    //             '1cb87720b3cbf6fedaf2460bddd0127527f1b8d4310dfdc661c3d658fea0ac505e276b509523a3d9c46fe5cc0ceeb56c',
    //         deleted: false,
    //         DivisionID: '24',
    //         LanguageID: '1',
    //         OwnerID: '48',
    //         pdfFonts: {
    //             lease: 'Arial',
    //             receipt: 'Arial',
    //             insuranceDocs: 'Arial',
    //         },
    //         scaConfiguration: {},
    //         collections: {
    //             unitTypeGroup: {
    //                 name: 'unitTypeGroup',
    //                 job: 'CRAG/GEP/unitTypeGroup',
    //                 status: 'finished',
    //                 timestamp: 1710547699135,
    //             },
    //             marketingSource: {
    //                 name: 'marketingSource',
    //                 job: 'CRAG/GEP/marketingSource',
    //                 status: 'finished',
    //                 timestamp: 1710547699135,
    //             },
    //             paymentSettings: {
    //                 name: 'paymentSettings',
    //                 job: 'CRAG/GEP/paymentSettings',
    //                 status: 'finished',
    //                 timestamp: 1710547699136,
    //             },
    //             discountPlan: {
    //                 name: 'discountPlan',
    //                 job: 'CRAG/GEP/discountPlan',
    //                 status: 'finished',
    //                 timestamp: 1710547699136,
    //             },
    //             chargeDescription: {
    //                 name: 'chargeDescription',
    //                 job: 'CRAG/GEP/chargeDescription',
    //                 status: 'finished',
    //                 timestamp: 1710547699135,
    //             },
    //             unitsFull: {
    //                 name: 'unitsFull',
    //                 job: 'CRAG/GEP/unitsFull',
    //                 status: 'finished',
    //                 timestamp: 1710547699135,
    //             },
    //             insuranceCoverage: {
    //                 name: 'insuranceCoverage',
    //                 job: 'CRAG/GEP/insuranceCoverage',
    //                 status: 'finished',
    //                 timestamp: 1710547699135,
    //             },
    //             site: {
    //                 name: 'site',
    //                 job: 'CRAG/GEP/site',
    //                 status: 'finished',
    //                 timestamp: 1710547699135,
    //             },
    //             paymentTypes: {
    //                 name: 'paymentTypes',
    //                 job: 'CRAG/GEP/paymentTypes',
    //                 status: 'finished',
    //                 timestamp: 1710547699136,
    //             },
    //             inventory: {
    //                 name: 'inventory',
    //                 job: 'CRAG/GEP/inventory',
    //                 status: 'finished',
    //                 timestamp: 1710547699135,
    //             },
    //             form: {
    //                 name: 'form',
    //                 job: 'CRAG/GEP/form',
    //                 status: 'finished',
    //                 timestamp: 1710547699136,
    //             },
    //         },
    //         friendlyName: null,
    //         originalName: 'U-Store-It Gepps Cross',
    //         personas: [
    //             {
    //                 _id: '65e69e4d7689a584c94d3546',
    //                 enabled: true,
    //                 name: 'Personal',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'personal',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //             {
    //                 _id: '65e69e4d7689a5b8154d3548',
    //                 enabled: true,
    //                 name: 'Vehicle',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'vehicle',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //             {
    //                 _id: '65e69e4d7689a5152e4d3547',
    //                 enabled: true,
    //                 name: 'Business',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'business',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //         ],
    //         sCorpCode: 'CRAG',
    //     },
    //     {
    //         SiteID: 1828,
    //         sLocationCode: 'LON',
    //         sGlobalSiteNum: '14536',
    //         iMobileType: '0',
    //         iRegionalOptions: 1,
    //         iOnLineChargeType: '0',
    //         bFeatMobileStorage: 'false',
    //         iGMTTimeOffset: 10,
    //         sLocationDesc: null,
    //         sSiteIDCode: null,
    //         sSiteRegionCode: null,
    //         sContactName: 'Chris Elze',
    //         sEmailAddress: 'lonsdale@ustoreit.com.au',
    //         sSiteName: 'U-Store-It Lonsdale',
    //         sSiteAddr1: '20 Aldenhoven Road',
    //         sSiteAddr2: null,
    //         sSiteCity: 'Lonsdale',
    //         sSiteRegion: 'SA',
    //         sSitePostalCode: '5160',
    //         sSiteCountry: 'AUS',
    //         sSitePhone: '08 8384 4333',
    //         sSiteFAX: '.',
    //         sWebSiteURL: null,
    //         iFeatMaxUnits: '1250',
    //         bFeatGate: 'true',
    //         bFeatKiosk: 'true',
    //         bFeatRevMgmt: 'true',
    //         bFeatCreditCards: 'true',
    //         bFeatCorpOffice: 'true',
    //         bFeatAccounting: 'true',
    //         bFeatRecordStorage: 'false',
    //         bFeatACH: 'true',
    //         dACHStatus: '2010-11-03T11:02:45.943-04:00',
    //         bLiteVersion: 'false',
    //         bTrial: 'false',
    //         bSubscription: 'false',
    //         bSiteDisabled: 'false',
    //         dGateUpdated: '2024-03-16T08:30:44.957-04:00',
    //         dOvernightProcess: '2024-03-16T10:05:40.233-04:00',
    //         sLegalName: 'U-Store-It Pty Ltd',
    //         bZipCodeData_Use: 'false',
    //         dcLongitude: '138.4954400000',
    //         dcLatitude: '-35.1137220000',
    //         bClosedWeekdays: 'false',
    //         bClosedSaturday: 'false',
    //         bClosedSunday: 'true',
    //         dWeekdayStrt: '2010-06-04T08:30:00-04:00',
    //         dWeekdayEnd: '2010-06-04T17:00:59-04:00',
    //         dSaturdayStrt: '2010-06-04T08:30:00-04:00',
    //         dSaturdayEnd: '2010-06-04T16:00:59-04:00',
    //         dSundayStrt: '2010-06-04T08:30:00-04:00',
    //         dSundayEnd: '2010-06-04T12:00:59-04:00',
    //         bPermanent: 'false',
    //         dUpdated: '2024-03-16T14:05:40.233Z',
    //         uTS: 'AAAAABxQcmE=',
    //         bFeatPromoAdvanced: 'false',
    //         iIdentifier: '0',
    //         sIdentifier: null,
    //         bUseInclusiveTaxation: true,
    //         bArchived: 'false',
    //         iBusinessType: '-35',
    //         iSiteDataType: '0',
    //         sTaxNumber: '53 659 430 120',
    //         iFacilityUsage: '0',
    //         iFacilityOwnership: '0',
    //         iFacilityMgmt: '0',
    //         iFacilityLocType: '0',
    //         iMobileBungoRules: '0',
    //         dCreated: '2010-06-03T00:00:00-04:00',
    //         iOnLinePmtsAllowed: '1',
    //         iEdition: '1',
    //         iTerminalServices: '0',
    //         iDST: '0',
    //         iVerboseLogging: '0',
    //         iSiteLinkStoreTier: '1',
    //         sSLBillingRef: 'RAGLON',
    //         iSubscriptionType: '0',
    //         tWeekdayStrt: '08:30:00',
    //         tWeekdayEnd: '17:00:59',
    //         tSaturdayStrt: '08:30:00',
    //         tSaturdayEnd: '16:00:59',
    //         tSundayStrt: '08:30:00',
    //         tSundayEnd: '12:00:59',
    //         rapidstorEnabled: true,
    //         bForcePushRates: '0',
    //         iWebRatesType: '0',
    //         ownerId: '48',
    //         languageId: '1',
    //         divisionId: '24',
    //         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //         hours: {
    //             officeMondayOpen: '8:30am',
    //             officeTuesdayOpen: '8:30am',
    //             officeWednesdayOpen: '8:30am',
    //             officeThursdayOpen: '8:30am',
    //             officeFridayOpen: '8:30am',
    //             officeSaturdayOpen: '8:30am',
    //             officeSundayOpen: 'Closed',
    //             officeMondayClose: '5:00pm',
    //             officeTuesdayClose: '5:00pm',
    //             officeWednesdayClose: '5:00pm',
    //             officeThursdayClose: '5:00pm',
    //             officeFridayClose: '5:00pm',
    //             officeSaturdayClose: '4:00pm',
    //             officeSundayClose: '',
    //             gateOpen: '5:00am',
    //             gateClose: '10:00pm',
    //             gateOpenWeekend: '5:00am',
    //             gateCloseWeekend: '10:00pm',
    //             gateCloseSaturday: '5:00pm',
    //             gateCloseSunday: '5:00pm',
    //             gateOpenSaturday: '9:00am',
    //             gateOpenSunday: '9:00am',
    //         },
    //         skin: {
    //             accentColours: {
    //                 primary: '#FFE700',
    //             },
    //             defaultUnitPicture: 'https://ik.imagekit.io/bytcx9plm/3x3_f.png',
    //             mainColour: '#ED1F15',
    //             highlightColour: '#CFD8DC',
    //             moveinTimeRemaining: false,
    //             themeColour: ''
    //         },
    //         administrative: {
    //             boxshopEnabled: true,
    //             testMode: false,
    //             rslite: false,
    //             rsliteKey: 'N/A',
    //             refreshEnabled: false,
    //             availableForUse: false,
    //             insuranceEnabled: false,
    //             merchEnabled: false,
    //             carouselListing: false,
    //             useMtasForAuth: false,
    //             featureAllowReservationsWhenNoAvailability: false,
    //             spacerIntegration: false,
    //             couponCloning: false
    //         },
    //         rapidstor: {
    //             pushRate: false,
    //             marketingSurvey: {
    //                 use: false,
    //                 questions: {
    //                     whereHearAboutUs: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     distanceFromFacility: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whyStoring: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     customerType: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whatStoring: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whyStoringWithUs: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                 },
    //             },
    //             country: 'AU',
    //             unitListing: {
    //                 sortOrder: {
    //                     primary: 'size',
    //                     secondary: 'price',
    //                     tertiary: 'availability',
    //                 },
    //                 useMultilevel: false,
    //             },
    //             siteLogo:
    //                 'https://ik.imagekit.io/bytcx9plm/CRAG-LON-logo-cjnmbqrxl0002s8moar1lcemd.png',
    //             allowOriginUrl: [],
    //             allowedCreditCardTypes: {
    //                 visa: true,
    //                 mastercard: true,
    //                 amex: false,
    //             },
    //             facilitySelfService: {
    //                 enquiries: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-enquiries.png',
    //                 },
    //                 takePayment: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-take-payment.png',
    //                 },
    //                 moveOut: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-moveout.png',
    //                 },
    //                 boxshop: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-boxshop.png',
    //                 },
    //             },
    //             tieredPricing: {
    //                 showTiersWithNoAvailableUnits: true,
    //                 noAvailableUnitsText: 'Call for Availability',
    //                 cherryPickBasis: 'lowestRate',
    //                 hidePrices: false,
    //                 hideQuickSearch: false,
    //                 showAvailableUnitsCount: false,
    //                 showPricesShowNeeded: true,
    //                 showVehicleQuickSearch: false,
    //                 noAvailableUnitsSecondaryAction: '',
    //                 noAvailableUnitsSecondaryText: ''
    //             },
    //             language: {
    //                 selectionOption: 'auto-detect',
    //             },
    //             siteLinkLeaseFields: [],
    //             useBoxShopCoupons: false,
    //             useDealCoupons: false,
    //             wizards: {
    //                 moveinSingle: {
    //                     hideAlternativeContact: false,
    //                     hideBoxshop: true,
    //                     hideInsurance: true,
    //                     insuranceRequired: false,
    //                     hideDriversLicence: false,
    //                     hideDriversLicenceState: true,
    //                     hideDateOfBirth: true,
    //                     hideState: false,
    //                     hidePostalCode: false,
    //                     allowIdUpload: false,
    //                     allowProofOfAddressUpload: false,
    //                     allowProofOfInsuranceUpload: false,
    //                     hideInsurancePicker: false,
    //                     insuranceAcceptancePopoverText: '',
    //                     insuranceAcceptanceText: 'By ticking this box you accept and agree; that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C’s below and understand the inclusions/exclusions of the policy.',
    //                     insuranceContent: '',
    //                     insuranceContentPopoverText: '',
    //                     insuranceManualEntry: false,
    //                     insuranceManualEntryRequired: false,
    //                     insuranceRefusedPopoverText: '',
    //                     insuranceRefusedText: 'By ticking this box, you are choosing not to be covered by insurance and acknowledge that we will not be held responsible for any damaged or lost goods during your rental period.',
    //                     requireAlternativeContactPhoneNumberField: true,
    //                     hideDriversLicence_state: false,
    //                     allowSelfInsurance: false,
    //                     hide_postalCode: false,
    //                     distinguishCustomerTypes: false
    //                 },
    //                 moveinStandard: {
    //                     requireAlternativeContactPhoneNumberField: true,
    //                 },
    //                 reservationWithFeeStandard: {},
    //             },
    //             features: {
    //                 'movein-wizard': 'single-page',
    //                 'unit-listing': 'standard',
    //                 boxshop: 'standard',
    //                 'reservation-with-fee-wizard': 'standard',
    //                 'tiered-unit-listing': 'standard',
    //                 'facility-self-service': 'standard',
    //                 'facility-staff-self-service': 'standard',
    //                 'tenant-accounts': 'standard',
    //                 'carousel-unit-listing': 'standard',
    //             },
    //             paymentGateways: {
    //                 use: false,
    //                 gatewayToUse: '',
    //                 paypal: {
    //                     currency: '',
    //                     clientId: '',
    //                     clientSecret: '',
    //                     useTestEnv: false,
    //                     force3dsCheck: false,
    //                 },
    //                 paytabs: {
    //                     merchantEmail: '',
    //                     secretKey: '',
    //                     merchantSiteUrl: '',
    //                     countryCode: '',
    //                     messageLanguage: '',
    //                     merchantId: '',
    //                     currency: ''
    //                 },
    //                 bypassSitelinkProcessing: false,
    //                 paygate: {
    //                     countryCode: '',
    //                     currency: '',
    //                     encryptionKey: '',
    //                     locale: '',
    //                     payMethod: '',
    //                     paygateId: '',
    //                 },
    //                 paynamics: {
    //                     countryCode: 'PH',
    //                     currency: '',
    //                     merchantId: '',
    //                     merchantKey: '',
    //                     merchantTermsUrl: '',
    //                     paymentMethods: ['bn', 'cc', 'dp', 'gc', 'pp'],
    //                     secure3d: 'try3d',
    //                 },
    //                 r6Pay: {
    //                     currency: '',
    //                     useTestEnv: false,
    //                 },
    //             },
    //             minAvailableUnits: 1,
    //             hideUnitsMinAvailable: false,
    //             noAvailableUnitsText: 'Call for Availability',
    //             hideQuickSearch: false,
    //             smallMediumSize: 5,
    //             mediumLargeSize: 13,
    //             moveinHideAcp: false,
    //             insuranceRequired: false,
    //             hideBoxshop: true,
    //             hideInsurance: true,
    //             hideLicense: false,
    //             hideLicenseState: true,
    //             hideDateOfBirth: true,
    //             hideState: false,
    //             hidePostalCode: false,
    //             autoOptInSms: false,
    //             currencySymbol: '$',
    //             sizeSymbol: 'm',
    //             groundFloor: 0,
    //             billingDefault: 'MonthlyAnniversary',
    //             shippingEnabled: false,
    //             legacyPickupLocationsEnabled: false,
    //             legacyPickupLocations: null,
    //             shippingInventoryItem: null,
    //             freeShippingDealEnabled: false,
    //             freeShippingDealAmount: 150,
    //             allowReservation: true,
    //             allowMoveIn: true,
    //             reservationNumberOfDaysInAdvanceLimit: 30,
    //             moveinNumberOfDaysInAdvanceLimit: 7,
    //             reservationNumberOfDaysInAdvanceChargeFee: 365,
    //             assistanceMoving: false,
    //             assistanceMovingEmailAddress: '',
    //             notificationsFromAddress: '',
    //             completeMoveinUrl: '',
    //             useESign: false,
    //             useAutoBilling: true,
    //             autoBillCheckedByDefault: false,
    //             doNotSendInvoiceSiteLinkWhenAutoBill: false,
    //             quickReserveButtonText: 'Quick Reserve',
    //             reservationExpireReservationDays: 30,
    //             notificationsAdditionalCcAddresses: [],
    //             areaSizeSymbol: 'm²',
    //             allowReservationsWhenNoAvailability: false,
    //             attachInsuranceDocsToMoveInConfirmationEmail: false,
    //             attachLeaseToMoveInConfirmationEmail: true,
    //             attachReceiptToMoveInConfirmationEmail: true,
    //             autoESignRedirect: false,
    //             autoOptInSMS: false,
    //             bookOnlineDiscount: 0,
    //             boxshopCategoryAlphaOrder: false,
    //             boxshopPurchaseAttachmentName: '',
    //             boxshopPurchaseEmailSubject: '',
    //             boxshopTermsConditions: '',
    //             checkForExistingTenant: false,
    //             completeMoveinURL: '',
    //             currency: 'AUD',
    //             dateFormat: 'yyyy-MM-dd',
    //             datesClosed: '',
    //             delayedInsurance: {
    //                 enabled: false,
    //                 timings: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //             },
    //             documentVerification: {
    //                 enabled: false,
    //                 providerToUse: null,
    //                 providers: {
    //                     rapidId: {
    //                         label: 'RapidID',
    //                         token: null,
    //                     },
    //                 },
    //             },
    //             eSignInsuranceForm: {
    //                 sFormName: null,
    //             },
    //             eSignInsuranceFormName: '',
    //             eSignMoveInDocumentNames: [],
    //             eSignMoveInDocuments: [],
    //             eSignReturnUrl: '',
    //             emailSchedules: {
    //                 quoteUnlockFirstReminder: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //                 quoteUnlockSecondReminder: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //                 reservationNotMovedIn: {
    //                     days: null,
    //                     hours: null,
    //                     mintues: null,
    //                 },
    //                 quoteEmail: {
    //                     '1': {
    //                         subject: null,
    //                     },
    //                     '2': {
    //                         days: null,
    //                         hours: null,
    //                         minutes: null,
    //                         subject: null,
    //                     },
    //                     '3': {
    //                         days: null,
    //                         hours: null,
    //                         minutes: null,
    //                         subject: null,
    //                     },
    //                 },
    //             },
    //             enquiryAPI: {
    //                 numOptions: 3,
    //             },
    //             forceTaxInclusive: false,
    //             hidePrices: false,
    //             includeFutureMoveOut: false,
    //             includeReservedUnitsInOccupied: true,
    //             insuranceCustomFormat: '',
    //             insuranceEsignReturnUrl: '',
    //             insurancePolicyNumberRange: {
    //                 end: null,
    //                 start: null,
    //             },
    //             insurancePolicyNumberRefreshNum: null,
    //             insuranceSmsFollowUpContent: '',
    //             kioskUnitListing: 'standard',
    //             locationPageUrl: '',
    //             moveinEmailSubject: '',
    //             moveinHideACP: false,
    //             moveinRedirectUrl: '',
    //             notificationsAdditionalBCCAddresses: [],
    //             notificationsAdditionalCCAddresses: [],
    //             notificationsFromName: '',
    //             notificationsReplyAddress: '',
    //             payLaterButtonText: 'Pay Later',
    //             payNowButtonText: 'Pay Now',
    //             pickupEnabled: true,
    //             recaptcha: {
    //                 enabled: false,
    //                 secretKey: '',
    //                 siteKey: '',
    //                 tolerance: 0.5,
    //             },
    //             reservationEmailSubject: '',
    //             reservationExpireOccupancyValues: {
    //                 bands: [
    //                     {
    //                         days: 30,
    //                         from: 0,
    //                         to: 100,
    //                     },
    //                 ],
    //                 enabled: false,
    //             },
    //             reservationPopupText: '',
    //             resetPasswordUrl: '',
    //             scheduleFollowUpEmails: false,
    //             showAreaInsteadOfDimensions: false,
    //             showAutobillTerms: false,
    //             showMoveInDateLimitMessage: false,
    //             showPricesButtonText: 'Show Prices',
    //             showPricesShowNeeded: true,
    //             showVehicleQuickSearch: false,
    //             showWeeklyRates: false,
    //             siteOpeningDate: null,
    //             sitelinkCostRetrieveChargeNameSubstiutions: [],
    //             spaceCalculatorValues: {
    //                 bedroom: 4,
    //                 box: 0.05,
    //                 garage: 7,
    //                 highestValue: {
    //                     area: 20,
    //                     high: 30,
    //                     low: 18,
    //                 },
    //                 largeItem: 1.5,
    //                 largeRoom: 5,
    //                 lowestValue: {
    //                     area: 3,
    //                     high: 5,
    //                     low: 1,
    //                 },
    //                 room: 4,
    //                 smallItem: 0.5,
    //                 smallRoom: 3,
    //             },
    //             tenantAccounts: {
    //                 autoPayment: {
    //                     enabled: true,
    //                 },
    //                 invoiceHistory: {
    //                     enabled: true,
    //                     showChargeBatch: false
    //                 },
    //                 makePayment: {
    //                     enabled: true,
    //                 },
    //                 paymentHistory: {
    //                     enabled: true,
    //                 },
    //                 tenantInfo: {
    //                     enabled: true,
    //                 },
    //                 uploadDocuments: {
    //                     enabled: true,
    //                     generalContent:
    //                         'Please select & upload the following documents as a pdf or image.',
    //                     proofOfAddress: {
    //                         content:
    //                             'Please upload a photo which has proof of your current address. Examples are bank statement, credit card statement or utility bill.',
    //                         enabled: true,
    //                         label: 'Proof of Address',
    //                     },
    //                     proofOfId: {
    //                         content:
    //                             "Please upload a photo of one of your identity documents such as your Driver's Licence or National Identity Card in JPG format.",
    //                         enabled: true,
    //                         label: 'Proof of Identification',
    //                     },
    //                     proofOfInsurance: {
    //                         content:
    //                             'Please upload a document which has proof of you being insured for your declared amount.',
    //                         enabled: true,
    //                         label: 'Proof of Insurance',
    //                     },
    //                 },
    //                 enableMultiSiteLogin: {
    //                     enabled: false,
    //                 },
    //                 notification: {
    //                     content: null,
    //                     ctaButton: {
    //                         text: null,
    //                     },
    //                     enabled: false,
    //                 },
    //             },
    //             twilio: {
    //                 accountSid: '',
    //                 authToken: '',
    //                 enabled: false,
    //                 senderId: '',
    //             },
    //             useDescriptorTitle: false,
    //             useESignForInsuranceDocs: false,
    //             useWebRates: false,
    //             webhooks: {
    //                 docUpload: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 moveIn: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 pageLoad: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 reservation: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 reservationWithFee: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 leadFollowUp: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //             },
    //             directDebit: {
    //                 creditAmount: 0,
    //                 enabled: false,
    //             },
    //             requireAutobill: false,
    //             sendReservationEmailOnFeeFailure: false,
    //             allowSaveQuote: false,
    //             saveQuoteButtonText: 'Save My Quote',
    //             saveQuotePopupText: '',
    //             ccSiteEmailInSaveQuote: true,
    //             creditCardForAutobill: {
    //                 enabled: true,
    //             },
    //         },
    //         fees: {
    //             moveOutNotice: 7,
    //             lateDays: 14,
    //             lateFee: 15,
    //             adminFee: 20,
    //             nsfFee: 11,
    //             cleaningFee: '15',
    //             securityDeposit: 0,
    //         },
    //         changedAt: '2024-03-17T13:46:40.483Z',
    //         changeToken:
    //             'e35e6a067339917f1cc0bacba015b9cec53b8ddf6e1e29d107a3ed46bf103a6270062abdd53e50a8eb700160271e8f67',
    //         deleted: false,
    //         DivisionID: '24',
    //         LanguageID: '1',
    //         OwnerID: '48',
    //         scaConfiguration: {},
    //         pdfFonts: {
    //             insuranceDocs: 'Arial',
    //             lease: 'Arial',
    //             receipt: 'Arial',
    //         },
    //         collections: {
    //             unitTypeGroup: {
    //                 name: 'unitTypeGroup',
    //                 job: 'CRAG/LON/unitTypeGroup',
    //                 status: 'finished',
    //                 timestamp: 1710547699136,
    //             },
    //             marketingSource: {
    //                 name: 'marketingSource',
    //                 job: 'CRAG/LON/marketingSource',
    //                 status: 'finished',
    //                 timestamp: 1710547699136,
    //             },
    //             inventory: {
    //                 name: 'inventory',
    //                 job: 'CRAG/LON/inventory',
    //                 status: 'finished',
    //                 timestamp: 1710547699136,
    //             },
    //             insuranceCoverage: {
    //                 name: 'insuranceCoverage',
    //                 job: 'CRAG/LON/insuranceCoverage',
    //                 status: 'finished',
    //                 timestamp: 1710547699136,
    //             },
    //             site: {
    //                 name: 'site',
    //                 job: 'CRAG/LON/site',
    //                 status: 'finished',
    //                 timestamp: 1710547699136,
    //             },
    //             unitsFull: {
    //                 name: 'unitsFull',
    //                 job: 'CRAG/LON/unitsFull',
    //                 status: 'finished',
    //                 timestamp: 1710547699136,
    //             },
    //             chargeDescription: {
    //                 name: 'chargeDescription',
    //                 job: 'CRAG/LON/chargeDescription',
    //                 status: 'finished',
    //                 timestamp: 1710547699136,
    //             },
    //             discountPlan: {
    //                 name: 'discountPlan',
    //                 job: 'CRAG/LON/discountPlan',
    //                 status: 'finished',
    //                 timestamp: 1710547699137,
    //             },
    //             paymentSettings: {
    //                 name: 'paymentSettings',
    //                 job: 'CRAG/LON/paymentSettings',
    //                 status: 'finished',
    //                 timestamp: 1710547699137,
    //             },
    //             form: {
    //                 name: 'form',
    //                 job: 'CRAG/LON/form',
    //                 status: 'finished',
    //                 timestamp: 1710547699137,
    //             },
    //             paymentTypes: {
    //                 name: 'paymentTypes',
    //                 job: 'CRAG/LON/paymentTypes',
    //                 status: 'finished',
    //                 timestamp: 1710461195205,
    //             },
    //         },
    //         friendlyName: null,
    //         originalName: 'U-Store-It Lonsdale',
    //         personas: [
    //             {
    //                 _id: '65e69e4d7689a584c94d3546',
    //                 enabled: true,
    //                 name: 'Personal',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'personal',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //             {
    //                 _id: '65e69e4d7689a5b8154d3548',
    //                 enabled: true,
    //                 name: 'Vehicle',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'vehicle',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //             {
    //                 _id: '65e69e4d7689a5152e4d3547',
    //                 enabled: true,
    //                 name: 'Business',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'business',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //         ],
    //         sCorpCode: 'CRAG',
    //     },
    //     {
    //         SiteID: 1430,
    //         sLocationCode: 'LSETUPS',
    //         sGlobalSiteNum: '14138',
    //         iMobileType: '0',
    //         iRegionalOptions: 1,
    //         iOnLineChargeType: '0',
    //         bFeatMobileStorage: 'false',
    //         iGMTTimeOffset: -5,
    //         sLocationDesc: null,
    //         sSiteRegionCode: null,
    //         sContactName: 'Andrew Eastwood',
    //         sEmailAddress: 'aeastwood@ustoreit.com.au',
    //         sSiteName: 'U-Store-It',
    //         sSiteAddr1: '1268 South Road',
    //         sSiteAddr2: null,
    //         sSiteCity: 'CLOVELLY PARK',
    //         sSiteRegion: 'SA',
    //         sSitePostalCode: '5042',
    //         sSiteCountry: 'AUS',
    //         sSitePhone: '08 82761166',
    //         sSiteFAX: '08 82775511',
    //         sWebSiteURL: null,
    //         iFeatMaxUnits: '125',
    //         bFeatGate: 'true',
    //         bFeatKiosk: 'true',
    //         bFeatRevMgmt: 'true',
    //         bFeatCreditCards: 'false',
    //         bFeatCorpOffice: 'true',
    //         bFeatAccounting: 'true',
    //         bFeatRecordStorage: 'false',
    //         bFeatACH: 'true',
    //         bLiteVersion: 'false',
    //         bTrial: 'false',
    //         bSubscription: 'false',
    //         bSiteDisabled: 'false',
    //         dOvernightProcess: '2024-03-17T01:00:03.357-04:00',
    //         sLegalName: null,
    //         bZipCodeData_Use: 'false',
    //         dcLongitude: '138.5751940000',
    //         dcLatitude: '-35.0038670000',
    //         bClosedWeekdays: 'false',
    //         bClosedSaturday: 'false',
    //         bClosedSunday: 'false',
    //         dWeekdayStrt: '2010-03-16T08:30:00-04:00',
    //         dWeekdayEnd: '2010-03-16T17:00:59-04:00',
    //         dSaturdayStrt: '2010-03-16T08:30:00-04:00',
    //         dSaturdayEnd: '2010-03-16T16:00:59-04:00',
    //         dSundayStrt: '2010-03-16T08:30:00-04:00',
    //         dSundayEnd: '2010-03-16T12:00:59-04:00',
    //         bPermanent: 'false',
    //         dUpdated: '2024-03-17T05:00:03.357Z',
    //         uTS: 'AAAAABxRC2I=',
    //         bFeatPromoAdvanced: 'false',
    //         iIdentifier: '0',
    //         bUseInclusiveTaxation: true,
    //         bArchived: 'false',
    //         iBusinessType: '0',
    //         iSiteDataType: '1',
    //         iFacilityUsage: '0',
    //         iFacilityOwnership: '0',
    //         iFacilityMgmt: '0',
    //         iFacilityLocType: '0',
    //         iMobileBungoRules: '0',
    //         dCreated: '2010-04-07T00:00:00-04:00',
    //         iOnLinePmtsAllowed: '0',
    //         iEdition: '1',
    //         iTerminalServices: '0',
    //         iDST: '0',
    //         iVerboseLogging: '0',
    //         iSiteLinkStoreTier: '1',
    //         iSubscriptionType: '0',
    //         tWeekdayStrt: '08:30:00',
    //         tWeekdayEnd: '17:00:59',
    //         tSaturdayStrt: '08:30:00',
    //         tSaturdayEnd: '16:00:59',
    //         tSundayStrt: '08:30:00',
    //         tSundayEnd: '12:00:59',
    //         rapidstorEnabled: true,
    //         ownerId: '48',
    //         languageId: '1',
    //         divisionId: '24',
    //         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //         hours: {
    //             officeMondayOpen: '9:00am',
    //             officeTuesdayOpen: '9:00am',
    //             officeWednesdayOpen: '9:00am',
    //             officeThursdayOpen: '9:00am',
    //             officeFridayOpen: '9:00am',
    //             officeSaturdayOpen: '9:00am',
    //             officeSundayOpen: '9:00am',
    //             officeMondayClose: '5:00pm',
    //             officeTuesdayClose: '5:00pm',
    //             officeWednesdayClose: '5:00pm',
    //             officeThursdayClose: '5:00pm',
    //             officeFridayClose: '5:00pm',
    //             officeSaturdayClose: '5:00pm',
    //             officeSundayClose: '5:00pm',
    //             gateOpen: '9:00am',
    //             gateClose: '5:00pm',
    //             gateOpenWeekend: '9:00am',
    //             gateCloseWeekend: '5:00pm',
    //             gateCloseSaturday: '5:00pm',
    //             gateCloseSunday: '5:00pm',
    //             gateOpenSaturday: '9:00am',
    //             gateOpenSunday: '9:00am',
    //         },
    //         skin: {
    //             accentColours: {
    //                 primary: '#FFE700',
    //             },
    //             mainColour: '#ED1F15',
    //             highlightColour: '#CFD8DC',
    //             moveinTimeRemaining: false,
    //             defaultUnitPicture: 'https://ik.imagekit.io/bytcx9plm/3x3_f.png',
    //             themeColour: ''
    //         },
    //         administrative: {
    //             boxshopEnabled: true,
    //             testMode: false,
    //             rslite: false,
    //             rsliteKey: 'N/A',
    //             refreshEnabled: false,
    //             availableForUse: false,
    //             insuranceEnabled: false,
    //             merchEnabled: false,
    //             carouselListing: false,
    //             useMtasForAuth: false,
    //             featureAllowReservationsWhenNoAvailability: false,
    //             spacerIntegration: false,
    //             couponCloning: false
    //         },
    //         rapidstor: {
    //             pushRate: false,
    //             marketingSurvey: {
    //                 use: true,
    //                 questions: {
    //                     whereHearAboutUs: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     distanceFromFacility: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whyStoring: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     customerType: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whatStoring: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whyStoringWithUs: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                 },
    //             },
    //             country: 'AU',
    //             unitListing: {
    //                 sortOrder: {
    //                     primary: 'size',
    //                     secondary: 'price',
    //                     tertiary: 'availability',
    //                 },
    //                 useMultilevel: false,
    //             },
    //             siteLogo:
    //                 'https://ik.imagekit.io/bytcx9plm/CRAG-LSETUPS-logo-ckpomqqug0007tcmo8sbhe64p.png',
    //             allowOriginUrl: [],
    //             allowedCreditCardTypes: {
    //                 visa: true,
    //                 mastercard: true,
    //                 amex: true,
    //             },
    //             minAvailableUnits: 0,
    //             hideUnitsMinAvailable: false,
    //             noAvailableUnitsText: 'Call for Availability',
    //             hideQuickSearch: false,
    //             smallMediumSize: 3,
    //             mediumLargeSize: 9,
    //             moveinHideAcp: false,
    //             insuranceRequired: false,
    //             hideBoxshop: false,
    //             hideInsurance: false,
    //             hideLicense: false,
    //             hideLicenseState: true,
    //             hideDateOfBirth: true,
    //             hideState: false,
    //             hidePostalCode: false,
    //             autoOptInSms: false,
    //             currencySymbol: '$',
    //             sizeSymbol: 'm',
    //             groundFloor: 0,
    //             billingDefault: 'MonthlyAnniversary',
    //             shippingEnabled: false,
    //             legacyPickupLocationsEnabled: false,
    //             legacyPickupLocations: null,
    //             shippingInventoryItem: null,
    //             freeShippingDealEnabled: false,
    //             freeShippingDealAmount: 150,
    //             allowReservation: true,
    //             allowMoveIn: true,
    //             reservationNumberOfDaysInAdvanceLimit: 30,
    //             moveinNumberOfDaysInAdvanceLimit: 7,
    //             reservationNumberOfDaysInAdvanceChargeFee: 365,
    //             assistanceMoving: false,
    //             assistanceMovingEmailAddress: '',
    //             notificationsFromAddress: '',
    //             completeMoveinUrl: '',
    //             useESign: false,
    //             useAutoBilling: true,
    //             autoBillCheckedByDefault: false,
    //             doNotSendInvoiceSiteLinkWhenAutoBill: false,
    //             areaSizeSymbol: 'm²',
    //             attachLeaseToMoveInConfirmationEmail: true,
    //             attachReceiptToMoveInConfirmationEmail: true,
    //             autoESignRedirect: false,
    //             autoOptInSMS: false,
    //             bookOnlineDiscount: 0,
    //             boxshopCategoryAlphaOrder: false,
    //             boxshopPurchaseAttachmentName: '',
    //             boxshopPurchaseEmailSubject: '',
    //             boxshopTermsConditions: '',
    //             checkForExistingTenant: false,
    //             completeMoveinURL: '',
    //             currency: 'AUD',
    //             dateFormat: 'yyyy-MM-dd',
    //             datesClosed: '',
    //             eSignInsuranceFormName: '',
    //             eSignMoveInDocumentNames: [],
    //             eSignMoveInDocuments: [],
    //             eSignReturnUrl: '',
    //             enquiryAPI: {
    //                 numOptions: 3,
    //             },
    //             facilitySelfService: {
    //                 boxshop: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-boxshop.png',
    //                 },
    //                 enquiries: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-enquiries.png',
    //                 },
    //                 moveOut: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-moveout.png',
    //                 },
    //                 takePayment: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-take-payment.png',
    //                 },
    //             },
    //             features: {
    //                 boxshop: 'standard',
    //                 'carousel-unit-listing': 'standard',
    //                 'facility-self-service': 'standard',
    //                 'facility-staff-self-service': 'standard',
    //                 'movein-wizard': 'single-page',
    //                 'reservation-with-fee-wizard': 'standard',
    //                 'tenant-accounts': 'standard',
    //                 'tiered-unit-listing': 'standard',
    //                 'unit-listing': 'standard',
    //             },
    //             forceTaxInclusive: false,
    //             hidePrices: false,
    //             insuranceCustomFormat: '',
    //             insuranceEsignReturnUrl: '',
    //             language: {
    //                 selectionOption: 'auto-detect',
    //             },
    //             locationPageUrl: '',
    //             moveinEmailSubject: '',
    //             moveinHideACP: false,
    //             moveinRedirectUrl: '',
    //             notificationsAdditionalBCCAddresses: [],
    //             notificationsAdditionalCCAddresses: [],
    //             notificationsReplyAddress: '',
    //             payLaterButtonText: 'Pay Later',
    //             payNowButtonText: 'Pay Now',
    //             paymentGateways: {
    //                 bypassSitelinkProcessing: false,
    //                 gatewayToUse: '',
    //                 paygate: {
    //                     countryCode: '',
    //                     currency: '',
    //                     encryptionKey: '',
    //                     locale: '',
    //                     payMethod: '',
    //                     paygateId: '',
    //                 },
    //                 paynamics: {
    //                     countryCode: 'PH',
    //                     currency: '',
    //                     merchantId: '',
    //                     merchantKey: '',
    //                     merchantTermsUrl: '',
    //                     paymentMethods: ['cc', 'bn', 'gc', 'pp', 'dp'],
    //                     secure3d: 'try3d',
    //                 },
    //                 paypal: {
    //                     clientId: '',
    //                     clientSecret: '',
    //                     currency: '',
    //                     useTestEnv: false,
    //                     force3dsCheck: false,
    //                 },
    //                 paytabs: {
    //                     countryCode: '',
    //                     merchantEmail: '',
    //                     merchantSiteUrl: '',
    //                     messageLanguage: '',
    //                     secretKey: '',
    //                     merchantId: '',
    //                     currency: ''
    //                 },
    //                 use: false,
    //                 r6Pay: {
    //                     currency: '',
    //                     useTestEnv: false,
    //                 },
    //             },
    //             pickupEnabled: true,
    //             quickReserveButtonText: 'Quick Reserve',
    //             recaptcha: {
    //                 enabled: false,
    //                 secretKey: '',
    //                 siteKey: '',
    //                 tolerance: 0.5,
    //             },
    //             reservationEmailSubject: '',
    //             reservationExpireOccupancyValues: {
    //                 bands: [
    //                     {
    //                         from: 0,
    //                         to: 100,
    //                         days: 30,
    //                     },
    //                 ],
    //                 enabled: false,
    //             },
    //             reservationExpireReservationDays: 30,
    //             reservationPopupText: '',
    //             resetPasswordUrl: '',
    //             scheduleFollowUpEmails: false,
    //             showAreaInsteadOfDimensions: false,
    //             showAutobillTerms: false,
    //             showPricesButtonText: 'Show Prices',
    //             showPricesShowNeeded: true,
    //             showVehicleQuickSearch: false,
    //             showWeeklyRates: false,
    //             siteLinkLeaseFields: [],
    //             sitelinkCostRetrieveChargeNameSubstiutions: [],
    //             spaceCalculatorValues: {
    //                 bedroom: 4,
    //                 box: 0.05,
    //                 garage: 7,
    //                 highestValue: {
    //                     area: 20,
    //                     high: 30,
    //                     low: 18,
    //                 },
    //                 largeItem: 1.5,
    //                 largeRoom: 5,
    //                 lowestValue: {
    //                     area: 3,
    //                     high: 5,
    //                     low: 1,
    //                 },
    //                 room: 4,
    //                 smallItem: 0.5,
    //                 smallRoom: 3,
    //             },
    //             tenantAccounts: {
    //                 autoPayment: {
    //                     enabled: true,
    //                 },
    //                 invoiceHistory: {
    //                     enabled: true,
    //                     showChargeBatch: false
    //                 },
    //                 makePayment: {
    //                     enabled: true,
    //                 },
    //                 paymentHistory: {
    //                     enabled: true,
    //                 },
    //                 tenantInfo: {
    //                     enabled: true,
    //                 },
    //                 uploadDocuments: {
    //                     enabled: true,
    //                     generalContent:
    //                         'Please select & upload the following documents as a pdf or image.',
    //                     proofOfAddress: {
    //                         content:
    //                             'Please upload a photo which has proof of your current address. Examples are bank statement, credit card statement or utility bill.',
    //                         enabled: true,
    //                         label: 'Proof of Address',
    //                     },
    //                     proofOfId: {
    //                         content:
    //                             "Please upload a photo of one of your identity documents such as your Driver's Licence or National Identity Card in JPG format.",
    //                         enabled: true,
    //                         label: 'Proof of Identification',
    //                     },
    //                     proofOfInsurance: {
    //                         content:
    //                             'Please upload a document which has proof of you being insured for your declared amount.',
    //                         enabled: true,
    //                         label: 'Proof of Insurance',
    //                     },
    //                 },
    //                 enableMultiSiteLogin: {
    //                     enabled: false,
    //                 },
    //                 notification: {
    //                     content: null,
    //                     ctaButton: {
    //                         text: null,
    //                     },
    //                     enabled: false,
    //                 },
    //             },
    //             tieredPricing: {
    //                 cherryPickBasis: 'lowestRate',
    //                 hidePrices: false,
    //                 hideQuickSearch: false,
    //                 noAvailableUnitsText: 'Call for Availability',
    //                 showAvailableUnitsCount: false,
    //                 showPricesShowNeeded: true,
    //                 showTiersWithNoAvailableUnits: true,
    //                 showVehicleQuickSearch: false,
    //                 noAvailableUnitsSecondaryAction: '',
    //                 noAvailableUnitsSecondaryText: ''
    //             },
    //             useBoxShopCoupons: false,
    //             useDealCoupons: false,
    //             useDescriptorTitle: false,
    //             useESignForInsuranceDocs: false,
    //             useWebRates: false,
    //             webhooks: {
    //                 docUpload: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 moveIn: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 pageLoad: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 reservation: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 reservationWithFee: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 leadFollowUp: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //             },
    //             wizards: {
    //                 moveinSingle: {
    //                     allowIdUpload: false,
    //                     allowProofOfAddressUpload: false,
    //                     allowProofOfInsuranceUpload: false,
    //                     hideAlternativeContact: true,
    //                     hideBoxshop: false,
    //                     hideDateOfBirth: true,
    //                     hideDriversLicence: false,
    //                     hideDriversLicenceState: true,
    //                     hideInsurance: false,
    //                     hideInsurancePicker: false,
    //                     hidePostalCode: false,
    //                     hideState: false,
    //                     insuranceAcceptancePopoverText: '',
    //                     insuranceAcceptanceText: 'By ticking this box you accept and agree; that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C’s below and understand the inclusions/exclusions of the policy.',
    //                     insuranceContent: '',
    //                     insuranceContentPopoverText: '',
    //                     insuranceManualEntry: false,
    //                     insuranceManualEntryRequired: false,
    //                     insuranceRefusedPopoverText: '',
    //                     insuranceRefusedText: 'By ticking this box, you are choosing not to be covered by insurance and acknowledge that we will not be held responsible for any damaged or lost goods during your rental period.',
    //                     insuranceRequired: false,
    //                     requireAlternativeContactPhoneNumberField: true,
    //                     hideDriversLicence_state: false,
    //                     allowSelfInsurance: false,
    //                     hide_postalCode: false,
    //                     distinguishCustomerTypes: false
    //                 },
    //                 moveinStandard: {
    //                     requireAlternativeContactPhoneNumberField: true,
    //                 },
    //                 reservationWithFeeStandard: {},
    //             },
    //             allowReservationsWhenNoAvailability: false,
    //             includeFutureMoveOut: false,
    //             includeReservedUnitsInOccupied: true,
    //             showMoveInDateLimitMessage: false,
    //             attachInsuranceDocsToMoveInConfirmationEmail: false,
    //             delayedInsurance: {
    //                 enabled: false,
    //                 timings: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //             },
    //             documentVerification: {
    //                 enabled: false,
    //                 providerToUse: null,
    //                 providers: {
    //                     rapidId: {
    //                         label: 'RapidID',
    //                         token: null,
    //                     },
    //                 },
    //             },
    //             eSignInsuranceForm: {
    //                 sFormName: null,
    //             },
    //             emailSchedules: {
    //                 quoteUnlockFirstReminder: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //                 quoteUnlockSecondReminder: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //                 reservationNotMovedIn: {
    //                     days: null,
    //                     hours: null,
    //                     mintues: null,
    //                 },
    //                 quoteEmail: {
    //                     '1': {
    //                         subject: 'SAVE QUOTE',
    //                     },
    //                     '2': {
    //                         days: 0,
    //                         hours: 0,
    //                         minutes: 0,
    //                         subject: 'TEST',
    //                     },
    //                     '3': {
    //                         days: 0,
    //                         hours: 0,
    //                         minutes: 0,
    //                         subject: 'TES',
    //                     },
    //                 },
    //             },
    //             insurancePolicyNumberRange: {
    //                 end: null,
    //                 start: null,
    //             },
    //             insurancePolicyNumberRefreshNum: null,
    //             insuranceSmsFollowUpContent: '',
    //             kioskUnitListing: 'standard',
    //             notificationsFromName: '',
    //             siteOpeningDate: null,
    //             twilio: {
    //                 accountSid: '',
    //                 authToken: '',
    //                 enabled: false,
    //                 senderId: '',
    //             },
    //             directDebit: {
    //                 creditAmount: 0,
    //                 enabled: false,
    //             },
    //             requireAutobill: false,
    //             sendReservationEmailOnFeeFailure: false,
    //             allowSaveQuote: true,
    //             saveQuoteButtonText: 'Save My Quote',
    //             saveQuotePopupText: '',
    //             ccSiteEmailInSaveQuote: true,
    //             creditCardForAutobill: {
    //                 enabled: true,
    //             },
    //         },
    //         fees: {
    //             moveOutNotice: 2,
    //             lateDays: 3,
    //             lateFee: 20,
    //             adminFee: 20,
    //             nsfFee: 20,
    //             cleaningFee: 50,
    //             securityDeposit: 100,
    //         },
    //         OwnerID: '48',
    //         LanguageID: '1',
    //         DivisionID: '24',
    //         bForcePushRates: '0',
    //         iWebRatesType: '0',
    //         changeToken:
    //             'f4a402f3f9e3762f7867b67cc31d884293c0cc65f7943cd30f2459eac18616e5d4bd630d8fa8fdd8a2ae6378b4ebd3b3',
    //         changedAt: '2024-03-17T19:54:28.087Z',
    //         deleted: false,
    //         pdfFonts: {
    //             lease: 'Arial',
    //             receipt: 'Arial',
    //             insuranceDocs: 'Arial',
    //         },
    //         scaConfiguration: {},
    //         collections: {
    //             unitTypeGroup: {
    //                 name: 'unitTypeGroup',
    //                 job: 'CRAG/LSETUPS/unitTypeGroup',
    //                 status: 'finished',
    //                 timestamp: 1710547699139,
    //             },
    //             insuranceCoverage: {
    //                 name: 'insuranceCoverage',
    //                 job: 'CRAG/LSETUPS/insuranceCoverage',
    //                 status: 'finished',
    //                 timestamp: 1710547699139,
    //             },
    //             form: {
    //                 name: 'form',
    //                 job: 'CRAG/LSETUPS/form',
    //                 status: 'finished',
    //                 timestamp: 1710547699140,
    //             },
    //             paymentSettings: {
    //                 name: 'paymentSettings',
    //                 job: 'CRAG/LSETUPS/paymentSettings',
    //                 status: 'finished',
    //                 timestamp: 1710547699140,
    //             },
    //             chargeDescription: {
    //                 name: 'chargeDescription',
    //                 job: 'CRAG/LSETUPS/chargeDescription',
    //                 status: 'finished',
    //                 timestamp: 1710547699139,
    //             },
    //             marketingSource: {
    //                 name: 'marketingSource',
    //                 job: 'CRAG/LSETUPS/marketingSource',
    //                 status: 'finished',
    //                 timestamp: 1710547699139,
    //             },
    //             inventory: {
    //                 name: 'inventory',
    //                 job: 'CRAG/LSETUPS/inventory',
    //                 status: 'finished',
    //                 timestamp: 1710547699139,
    //             },
    //             paymentTypes: {
    //                 name: 'paymentTypes',
    //                 job: 'CRAG/LSETUPS/paymentTypes',
    //                 status: 'finished',
    //                 timestamp: 1710547699140,
    //             },
    //             discountPlan: {
    //                 name: 'discountPlan',
    //                 job: 'CRAG/LSETUPS/discountPlan',
    //                 status: 'finished',
    //                 timestamp: 1710547699140,
    //             },
    //             unitsFull: {
    //                 name: 'unitsFull',
    //                 job: 'CRAG/LSETUPS/unitsFull',
    //                 status: 'finished',
    //                 timestamp: 1710547699139,
    //             },
    //             site: {
    //                 name: 'site',
    //                 job: 'CRAG/LSETUPS/site',
    //                 status: 'finished',
    //                 timestamp: 1710547699139,
    //             },
    //         },
    //         friendlyName: null,
    //         originalName: 'U-Store-It',
    //         personas: [
    //             {
    //                 _id: '65e69e4d7689a584c94d3546',
    //                 enabled: true,
    //                 name: 'Personal',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'personal',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //             {
    //                 _id: '65e69e4d7689a5b8154d3548',
    //                 enabled: true,
    //                 name: 'Vehicle',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'vehicle',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //             {
    //                 _id: '65e69e4d7689a5152e4d3547',
    //                 enabled: true,
    //                 name: 'Business',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'business',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //         ],
    //         sCorpCode: 'CRAG',
    //     },
    //     {
    //         SiteID: 1750,
    //         sLocationCode: 'MEL',
    //         sGlobalSiteNum: '14458',
    //         iMobileType: '0',
    //         iRegionalOptions: 1,
    //         iOnLineChargeType: '0',
    //         bFeatMobileStorage: 'false',
    //         iGMTTimeOffset: 8,
    //         sLocationDesc: null,
    //         sSiteIDCode: null,
    //         sSiteRegionCode: null,
    //         sContactName: 'Bec Kade',
    //         sEmailAddress: 'melrosepark@ustoreit.com.au',
    //         sSiteName: 'U-Store-It Melrose Park',
    //         sSiteAddr1: '130 Daws Road',
    //         sSiteAddr2: null,
    //         sSiteCity: 'Melrose Park',
    //         sSiteRegion: 'SA',
    //         sSitePostalCode: '5039',
    //         sSiteCountry: 'AUS',
    //         sSitePhone: '08 8357 6200',
    //         sSiteFAX: '.',
    //         sWebSiteURL: null,
    //         iFeatMaxUnits: '750',
    //         bFeatGate: 'true',
    //         bFeatKiosk: 'true',
    //         bFeatRevMgmt: 'true',
    //         bFeatCreditCards: 'true',
    //         bFeatCorpOffice: 'true',
    //         bFeatAccounting: 'true',
    //         bFeatRecordStorage: 'false',
    //         bFeatACH: 'true',
    //         dACHStatus: '2010-11-08T10:07:10.773-05:00',
    //         bLiteVersion: 'false',
    //         bTrial: 'false',
    //         bSubscription: 'false',
    //         bSiteDisabled: 'false',
    //         dGateUpdated: '2024-03-16T08:00:25.783-04:00',
    //         dOvernightProcess: '2024-03-16T12:05:16.707-04:00',
    //         sLegalName: 'U-Store-It Pty Ltd',
    //         bZipCodeData_Use: 'false',
    //         dcLongitude: '138.5782600000',
    //         dcLatitude: '-34.9919950000',
    //         bClosedWeekdays: 'false',
    //         bClosedSaturday: 'false',
    //         bClosedSunday: 'true',
    //         dWeekdayStrt: '2010-05-17T08:30:00-04:00',
    //         dWeekdayEnd: '2010-05-17T17:00:59-04:00',
    //         dSaturdayStrt: '2010-05-17T08:30:00-04:00',
    //         dSaturdayEnd: '2010-05-17T16:00:59-04:00',
    //         dSundayStrt: '2010-05-17T08:30:00-04:00',
    //         dSundayEnd: '2010-05-17T12:00:59-04:00',
    //         bPermanent: 'false',
    //         dUpdated: '2024-03-16T16:05:16.707Z',
    //         uTS: 'AAAAABxQ9vw=',
    //         bFeatPromoAdvanced: 'false',
    //         iIdentifier: '0',
    //         sIdentifier: null,
    //         bUseInclusiveTaxation: true,
    //         bArchived: 'false',
    //         iBusinessType: '-35',
    //         iSiteDataType: '0',
    //         sTaxNumber: '53 659 430 120',
    //         iFacilityUsage: '0',
    //         iFacilityOwnership: '0',
    //         iFacilityMgmt: '0',
    //         iFacilityLocType: '0',
    //         iMobileBungoRules: '0',
    //         dCreated: '2010-05-12T00:00:00-04:00',
    //         iOnLinePmtsAllowed: '1',
    //         iEdition: '1',
    //         iTerminalServices: '0',
    //         iDST: '0',
    //         iVerboseLogging: '0',
    //         iSiteLinkStoreTier: '1',
    //         sSLBillingRef: 'RAGMEL',
    //         iSubscriptionType: '0',
    //         tWeekdayStrt: '08:30:00',
    //         tWeekdayEnd: '17:00:59',
    //         tSaturdayStrt: '08:30:00',
    //         tSaturdayEnd: '16:00:59',
    //         tSundayStrt: '08:30:00',
    //         tSundayEnd: '12:00:59',
    //         rapidstorEnabled: true,
    //         bForcePushRates: '0',
    //         iWebRatesType: '0',
    //         ownerId: '48',
    //         languageId: '1',
    //         divisionId: '24',
    //         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //         hours: {
    //             officeMondayOpen: '8:00am',
    //             officeTuesdayOpen: '8:00am',
    //             officeWednesdayOpen: '8:00am',
    //             officeThursdayOpen: '8:00am',
    //             officeFridayOpen: '8:00am',
    //             officeSaturdayOpen: '8:30am',
    //             officeSundayOpen: 'Closed',
    //             officeMondayClose: '5:00pm',
    //             officeTuesdayClose: '5:00pm',
    //             officeWednesdayClose: '5:00pm',
    //             officeThursdayClose: '5:00pm',
    //             officeFridayClose: '5:00pm',
    //             officeSaturdayClose: '4:00pm',
    //             officeSundayClose: '',
    //             gateOpen: '5:00am',
    //             gateClose: '10:00pm',
    //             gateOpenWeekend: '5:00am',
    //             gateCloseWeekend: '10:00pm',
    //             gateCloseSaturday: '5:00pm',
    //             gateCloseSunday: '5:00pm',
    //             gateOpenSaturday: '9:00am',
    //             gateOpenSunday: '9:00am',
    //         },
    //         skin: {
    //             accentColours: {
    //                 primary: '#FFE700',
    //             },
    //             defaultUnitPicture: 'https://ik.imagekit.io/bytcx9plm/3x3_f.png',
    //             mainColour: '#ED1F15',
    //             highlightColour: '#CFD8DC',
    //             moveinTimeRemaining: false,
    //             themeColour: ''
    //         },
    //         administrative: {
    //             boxshopEnabled: true,
    //             testMode: false,
    //             rslite: false,
    //             rsliteKey: 'N/A',
    //             refreshEnabled: false,
    //             availableForUse: false,
    //             insuranceEnabled: false,
    //             merchEnabled: false,
    //             carouselListing: false,
    //             useMtasForAuth: false,
    //             featureAllowReservationsWhenNoAvailability: false,
    //             spacerIntegration: false,
    //             couponCloning: false
    //         },
    //         rapidstor: {
    //             pushRate: false,
    //             marketingSurvey: {
    //                 use: true,
    //                 questions: {
    //                     whereHearAboutUs: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     distanceFromFacility: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whyStoring: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     customerType: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whatStoring: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whyStoringWithUs: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                 },
    //             },
    //             country: 'AU',
    //             unitListing: {
    //                 sortOrder: {
    //                     primary: 'size',
    //                     secondary: 'price',
    //                     tertiary: 'availability',
    //                 },
    //                 useMultilevel: false,
    //             },
    //             siteLogo:
    //                 'https://ik.imagekit.io/bytcx9plm/CRAG-MEL-logo-cjpd81d050001fcmo0k0jvr4k.png',
    //             allowOriginUrl: ['https://www.ustoreit.com.au'],
    //             allowedCreditCardTypes: {
    //                 visa: true,
    //                 mastercard: true,
    //                 amex: true,
    //             },
    //             siteLinkLeaseFields: [],
    //             facilitySelfService: {
    //                 enquiries: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-enquiries.png',
    //                 },
    //                 takePayment: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-take-payment.png',
    //                 },
    //                 moveOut: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-moveout.png',
    //                 },
    //                 boxshop: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-boxshop.png',
    //                 },
    //             },
    //             tieredPricing: {
    //                 showTiersWithNoAvailableUnits: true,
    //                 noAvailableUnitsText: 'Call for Availability',
    //                 cherryPickBasis: 'lowestRate',
    //                 hidePrices: false,
    //                 hideQuickSearch: false,
    //                 showAvailableUnitsCount: false,
    //                 showPricesShowNeeded: true,
    //                 showVehicleQuickSearch: false,
    //                 noAvailableUnitsSecondaryAction: '',
    //                 noAvailableUnitsSecondaryText: ''
    //             },
    //             language: {
    //                 selectionOption: 'auto-detect',
    //             },
    //             useBoxShopCoupons: false,
    //             useDealCoupons: false,
    //             wizards: {
    //                 moveinSingle: {
    //                     hideAlternativeContact: false,
    //                     hideBoxshop: false,
    //                     hideInsurance: false,
    //                     insuranceRequired: false,
    //                     hideDriversLicence: false,
    //                     hideDriversLicenceState: true,
    //                     hideDateOfBirth: true,
    //                     hideState: false,
    //                     hidePostalCode: false,
    //                     allowIdUpload: false,
    //                     allowProofOfAddressUpload: false,
    //                     allowProofOfInsuranceUpload: false,
    //                     hideInsurancePicker: false,
    //                     insuranceAcceptancePopoverText: '',
    //                     insuranceAcceptanceText: 'By ticking this box you accept and agree; that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C’s below and understand the inclusions/exclusions of the policy.',
    //                     insuranceContent: '',
    //                     insuranceContentPopoverText: '',
    //                     insuranceManualEntry: false,
    //                     insuranceManualEntryRequired: false,
    //                     insuranceRefusedPopoverText: '',
    //                     insuranceRefusedText: 'By ticking this box, you are choosing not to be covered by insurance and acknowledge that we will not be held responsible for any damaged or lost goods during your rental period.',
    //                     requireAlternativeContactPhoneNumberField: true,
    //                     hideDriversLicence_state: false,
    //                     allowSelfInsurance: false,
    //                     hide_postalCode: false,
    //                     distinguishCustomerTypes: false
    //                 },
    //                 moveinStandard: {
    //                     requireAlternativeContactPhoneNumberField: true,
    //                 },
    //                 reservationWithFeeStandard: {},
    //             },
    //             features: {
    //                 'movein-wizard': 'single-page',
    //                 'unit-listing': 'standard',
    //                 boxshop: 'standard',
    //                 'reservation-with-fee-wizard': 'standard',
    //                 'tiered-unit-listing': 'standard',
    //                 'facility-self-service': 'standard',
    //                 'facility-staff-self-service': 'standard',
    //                 'tenant-accounts': 'standard',
    //                 'carousel-unit-listing': 'standard',
    //             },
    //             paymentGateways: {
    //                 use: false,
    //                 gatewayToUse: '',
    //                 paypal: {
    //                     currency: '',
    //                     clientId: '',
    //                     clientSecret: '',
    //                     useTestEnv: false,
    //                     force3dsCheck: false,
    //                 },
    //                 paytabs: {
    //                     merchantEmail: '',
    //                     secretKey: '',
    //                     merchantSiteUrl: '',
    //                     countryCode: '',
    //                     messageLanguage: '',
    //                     merchantId: '',
    //                     currency: ''
    //                 },
    //                 bypassSitelinkProcessing: false,
    //                 paygate: {
    //                     countryCode: '',
    //                     currency: '',
    //                     encryptionKey: '',
    //                     locale: '',
    //                     payMethod: '',
    //                     paygateId: '',
    //                 },
    //                 paynamics: {
    //                     countryCode: 'PH',
    //                     currency: '',
    //                     merchantId: '',
    //                     merchantKey: '',
    //                     merchantTermsUrl: '',
    //                     paymentMethods: ['bn', 'cc', 'dp', 'gc', 'pp'],
    //                     secure3d: 'try3d',
    //                 },
    //                 r6Pay: {
    //                     currency: '',
    //                     useTestEnv: false,
    //                 },
    //             },
    //             minAvailableUnits: 1,
    //             hideUnitsMinAvailable: false,
    //             noAvailableUnitsText: 'Call for Availability',
    //             hideQuickSearch: false,
    //             smallMediumSize: 7,
    //             mediumLargeSize: 13,
    //             moveinHideAcp: false,
    //             insuranceRequired: false,
    //             hideBoxshop: false,
    //             hideInsurance: false,
    //             hideLicense: false,
    //             hideLicenseState: true,
    //             hideDateOfBirth: true,
    //             hideState: false,
    //             hidePostalCode: false,
    //             autoOptInSms: false,
    //             currencySymbol: '$',
    //             sizeSymbol: 'm',
    //             groundFloor: 0,
    //             billingDefault: 'MonthlyAnniversary',
    //             shippingEnabled: false,
    //             legacyPickupLocationsEnabled: false,
    //             legacyPickupLocations: null,
    //             shippingInventoryItem: null,
    //             freeShippingDealEnabled: false,
    //             freeShippingDealAmount: 150,
    //             allowReservation: true,
    //             allowMoveIn: true,
    //             reservationNumberOfDaysInAdvanceLimit: 28,
    //             moveinNumberOfDaysInAdvanceLimit: 5,
    //             reservationNumberOfDaysInAdvanceChargeFee: 365,
    //             assistanceMoving: false,
    //             assistanceMovingEmailAddress: '',
    //             notificationsFromAddress: 'melrosepark@ustoreit.com.au',
    //             completeMoveinUrl: '',
    //             useESign: false,
    //             useAutoBilling: true,
    //             autoBillCheckedByDefault: false,
    //             doNotSendInvoiceSiteLinkWhenAutoBill: false,
    //             quickReserveButtonText: 'Quick Reserve',
    //             reservationExpireReservationDays: 30,
    //             notificationsAdditionalCcAddresses: [],
    //             areaSizeSymbol: 'm²',
    //             allowReservationsWhenNoAvailability: false,
    //             attachInsuranceDocsToMoveInConfirmationEmail: false,
    //             attachLeaseToMoveInConfirmationEmail: true,
    //             attachReceiptToMoveInConfirmationEmail: true,
    //             autoESignRedirect: false,
    //             autoOptInSMS: false,
    //             bookOnlineDiscount: 0,
    //             boxshopCategoryAlphaOrder: false,
    //             boxshopPurchaseAttachmentName: '',
    //             boxshopPurchaseEmailSubject: '',
    //             boxshopTermsConditions: '',
    //             checkForExistingTenant: false,
    //             completeMoveinURL: '',
    //             currency: 'AUD',
    //             dateFormat: 'yyyy-MM-dd',
    //             datesClosed: '',
    //             delayedInsurance: {
    //                 enabled: false,
    //                 timings: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //             },
    //             documentVerification: {
    //                 enabled: false,
    //                 providerToUse: null,
    //                 providers: {
    //                     rapidId: {
    //                         label: 'RapidID',
    //                         token: null,
    //                     },
    //                 },
    //             },
    //             eSignInsuranceForm: {
    //                 sFormName: null,
    //             },
    //             eSignInsuranceFormName: '',
    //             eSignMoveInDocumentNames: [],
    //             eSignMoveInDocuments: [],
    //             eSignReturnUrl: '',
    //             emailSchedules: {
    //                 quoteUnlockFirstReminder: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //                 quoteUnlockSecondReminder: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //                 reservationNotMovedIn: {
    //                     days: null,
    //                     hours: null,
    //                     mintues: null,
    //                 },
    //                 quoteEmail: {
    //                     '1': {
    //                         subject: null,
    //                     },
    //                     '2': {
    //                         days: null,
    //                         hours: null,
    //                         minutes: null,
    //                         subject: null,
    //                     },
    //                     '3': {
    //                         days: null,
    //                         hours: null,
    //                         minutes: null,
    //                         subject: null,
    //                     },
    //                 },
    //             },
    //             enquiryAPI: {
    //                 numOptions: 3,
    //             },
    //             forceTaxInclusive: false,
    //             hidePrices: false,
    //             includeFutureMoveOut: false,
    //             includeReservedUnitsInOccupied: true,
    //             insuranceCustomFormat: '',
    //             insuranceEsignReturnUrl: '',
    //             insurancePolicyNumberRange: {
    //                 end: null,
    //                 start: null,
    //             },
    //             insurancePolicyNumberRefreshNum: null,
    //             insuranceSmsFollowUpContent: '',
    //             kioskUnitListing: 'standard',
    //             locationPageUrl: '',
    //             moveinEmailSubject: '',
    //             moveinHideACP: false,
    //             moveinRedirectUrl: '',
    //             notificationsAdditionalBCCAddresses: [],
    //             notificationsAdditionalCCAddresses: [],
    //             notificationsFromName: '',
    //             notificationsReplyAddress: '',
    //             payLaterButtonText: 'Pay Later',
    //             payNowButtonText: 'Pay Now',
    //             pickupEnabled: true,
    //             recaptcha: {
    //                 enabled: false,
    //                 secretKey: '',
    //                 siteKey: '',
    //                 tolerance: 0.5,
    //             },
    //             reservationEmailSubject: '',
    //             reservationExpireOccupancyValues: {
    //                 bands: [
    //                     {
    //                         days: 30,
    //                         from: 0,
    //                         to: 100,
    //                     },
    //                 ],
    //                 enabled: false,
    //             },
    //             reservationPopupText: '',
    //             resetPasswordUrl: '',
    //             scheduleFollowUpEmails: false,
    //             showAreaInsteadOfDimensions: false,
    //             showAutobillTerms: false,
    //             showMoveInDateLimitMessage: false,
    //             showPricesButtonText: 'Show Prices',
    //             showPricesShowNeeded: true,
    //             showVehicleQuickSearch: false,
    //             showWeeklyRates: false,
    //             siteOpeningDate: null,
    //             sitelinkCostRetrieveChargeNameSubstiutions: [],
    //             spaceCalculatorValues: {
    //                 bedroom: 4,
    //                 box: 0.05,
    //                 garage: 7,
    //                 highestValue: {
    //                     area: 20,
    //                     high: 30,
    //                     low: 18,
    //                 },
    //                 largeItem: 1.5,
    //                 largeRoom: 5,
    //                 lowestValue: {
    //                     area: 3,
    //                     high: 5,
    //                     low: 1,
    //                 },
    //                 room: 4,
    //                 smallItem: 0.5,
    //                 smallRoom: 3,
    //             },
    //             tenantAccounts: {
    //                 autoPayment: {
    //                     enabled: true,
    //                 },
    //                 invoiceHistory: {
    //                     enabled: true,
    //                     showChargeBatch: false
    //                 },
    //                 makePayment: {
    //                     enabled: true,
    //                 },
    //                 paymentHistory: {
    //                     enabled: true,
    //                 },
    //                 tenantInfo: {
    //                     enabled: true,
    //                 },
    //                 uploadDocuments: {
    //                     enabled: true,
    //                     generalContent:
    //                         'Please select & upload the following documents as a pdf or image.',
    //                     proofOfAddress: {
    //                         content:
    //                             'Please upload a photo which has proof of your current address. Examples are bank statement, credit card statement or utility bill.',
    //                         enabled: true,
    //                         label: 'Proof of Address',
    //                     },
    //                     proofOfId: {
    //                         content:
    //                             "Please upload a photo of one of your identity documents such as your Driver's Licence or National Identity Card in JPG format.",
    //                         enabled: true,
    //                         label: 'Proof of Identification',
    //                     },
    //                     proofOfInsurance: {
    //                         content:
    //                             'Please upload a document which has proof of you being insured for your declared amount.',
    //                         enabled: true,
    //                         label: 'Proof of Insurance',
    //                     },
    //                 },
    //                 enableMultiSiteLogin: {
    //                     enabled: false,
    //                 },
    //                 notification: {
    //                     content: null,
    //                     ctaButton: {
    //                         text: null,
    //                     },
    //                     enabled: false,
    //                 },
    //             },
    //             twilio: {
    //                 accountSid: '',
    //                 authToken: '',
    //                 enabled: false,
    //                 senderId: '',
    //             },
    //             useDescriptorTitle: false,
    //             useESignForInsuranceDocs: false,
    //             useWebRates: false,
    //             webhooks: {
    //                 docUpload: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 moveIn: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 pageLoad: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 reservation: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 reservationWithFee: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 leadFollowUp: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //             },
    //             directDebit: {
    //                 creditAmount: 0,
    //                 enabled: false,
    //             },
    //             requireAutobill: false,
    //             sendReservationEmailOnFeeFailure: false,
    //             allowSaveQuote: false,
    //             saveQuoteButtonText: 'Save My Quote',
    //             saveQuotePopupText: '',
    //             ccSiteEmailInSaveQuote: true,
    //             creditCardForAutobill: {
    //                 enabled: true,
    //             },
    //         },
    //         fees: {
    //             moveOutNotice: 7,
    //             lateDays: 14,
    //             lateFee: 15,
    //             adminFee: 0,
    //             nsfFee: 11,
    //             cleaningFee: '15',
    //             securityDeposit: 0,
    //         },
    //         changedAt: '2024-03-17T05:12:25.676Z',
    //         changeToken:
    //             'e607967018fca511bc9b978cc7686be0661893adca12d8f5e8f9d8df71c84748c2e27a9a060587635059c2819d69fd49',
    //         deleted: false,
    //         DivisionID: '24',
    //         LanguageID: '1',
    //         OwnerID: '48',
    //         scaConfiguration: {},
    //         pdfFonts: {
    //             insuranceDocs: 'Arial',
    //             lease: 'Arial',
    //             receipt: 'Arial',
    //         },
    //         collections: {
    //             unitTypeGroup: {
    //                 name: 'unitTypeGroup',
    //                 job: 'CRAG/MEL/unitTypeGroup',
    //                 status: 'finished',
    //                 timestamp: 1710547699140,
    //             },
    //             site: {
    //                 name: 'site',
    //                 job: 'CRAG/MEL/site',
    //                 status: 'finished',
    //                 timestamp: 1710547699140,
    //             },
    //             paymentSettings: {
    //                 name: 'paymentSettings',
    //                 job: 'CRAG/MEL/paymentSettings',
    //                 status: 'finished',
    //                 timestamp: 1710547699143,
    //             },
    //             discountPlan: {
    //                 name: 'discountPlan',
    //                 job: 'CRAG/MEL/discountPlan',
    //                 status: 'finished',
    //                 timestamp: 1710547699143,
    //             },
    //             inventory: {
    //                 name: 'inventory',
    //                 job: 'CRAG/MEL/inventory',
    //                 status: 'finished',
    //                 timestamp: 1710547699143,
    //             },
    //             insuranceCoverage: {
    //                 name: 'insuranceCoverage',
    //                 job: 'CRAG/MEL/insuranceCoverage',
    //                 status: 'finished',
    //                 timestamp: 1710547699143,
    //             },
    //             chargeDescription: {
    //                 name: 'chargeDescription',
    //                 job: 'CRAG/MEL/chargeDescription',
    //                 status: 'finished',
    //                 timestamp: 1710547699140,
    //             },
    //             marketingSource: {
    //                 name: 'marketingSource',
    //                 job: 'CRAG/MEL/marketingSource',
    //                 status: 'finished',
    //                 timestamp: 1710547699143,
    //             },
    //             unitsFull: {
    //                 name: 'unitsFull',
    //                 job: 'CRAG/MEL/unitsFull',
    //                 status: 'finished',
    //                 timestamp: 1710547699140,
    //             },
    //             paymentTypes: {
    //                 name: 'paymentTypes',
    //                 job: 'CRAG/MEL/paymentTypes',
    //                 status: 'finished',
    //                 timestamp: 1710547699144,
    //             },
    //             form: {
    //                 name: 'form',
    //                 job: 'CRAG/MEL/form',
    //                 status: 'finished',
    //                 timestamp: 1710547699144,
    //             },
    //         },
    //         friendlyName: null,
    //         originalName: 'U-Store-It Melrose Park',
    //         Ret_Code: '-99',
    //         Ret_Msg: 'General Exception from LogOn',
    //         personas: [
    //             {
    //                 _id: '65e69e4d7689a584c94d3546',
    //                 enabled: true,
    //                 name: 'Personal',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'personal',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //             {
    //                 _id: '65e69e4d7689a5b8154d3548',
    //                 enabled: true,
    //                 name: 'Vehicle',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'vehicle',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //             {
    //                 _id: '65e69e4d7689a5152e4d3547',
    //                 enabled: true,
    //                 name: 'Business',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'business',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //         ],
    //         sCorpCode: 'CRAG',
    //     },
    //     {
    //         SiteID: 1781,
    //         sLocationCode: 'NOR',
    //         sGlobalSiteNum: '14489',
    //         iMobileType: '0',
    //         iRegionalOptions: 1,
    //         iOnLineChargeType: '0',
    //         bFeatMobileStorage: 'false',
    //         iGMTTimeOffset: 10,
    //         sLocationDesc: null,
    //         sSiteIDCode: null,
    //         sSiteRegionCode: null,
    //         sContactName: 'Sean Magee',
    //         sEmailAddress: 'norwood@ustoreit.com.au',
    //         sSiteName: 'U-Store-It Norwood',
    //         sSiteAddr1: '52 Sydenham Road',
    //         sSiteAddr2: null,
    //         sSiteCity: 'Norwood',
    //         sSiteRegion: 'SA',
    //         sSitePostalCode: '5067',
    //         sSiteCountry: 'AUS',
    //         sSitePhone: '08 8363 7155',
    //         sSiteFAX: '.',
    //         sWebSiteURL: null,
    //         iFeatMaxUnits: '1250',
    //         bFeatGate: 'true',
    //         bFeatKiosk: 'true',
    //         bFeatRevMgmt: 'true',
    //         bFeatCreditCards: 'true',
    //         bFeatCorpOffice: 'true',
    //         bFeatAccounting: 'true',
    //         bFeatRecordStorage: 'false',
    //         bFeatACH: 'true',
    //         dACHStatus: '2010-11-09T11:06:04.14-05:00',
    //         bLiteVersion: 'false',
    //         bTrial: 'false',
    //         bSubscription: 'false',
    //         bSiteDisabled: 'false',
    //         dGateUpdated: '2024-03-17T08:22:04.783-04:00',
    //         dOvernightProcess: '2024-03-17T10:06:20.283-04:00',
    //         sLegalName: 'U-Store-It Pty Ltd',
    //         bZipCodeData_Use: 'false',
    //         dcLongitude: '138.6280810000',
    //         dcLatitude: '-34.9198260000',
    //         bClosedWeekdays: 'false',
    //         bClosedSaturday: 'false',
    //         bClosedSunday: 'false',
    //         dWeekdayStrt: '2010-06-23T08:30:00-04:00',
    //         dWeekdayEnd: '2010-06-23T05:00:59-04:00',
    //         dSaturdayStrt: '2010-06-23T08:30:00-04:00',
    //         dSaturdayEnd: '2010-06-23T04:00:59-04:00',
    //         dSundayStrt: '2010-06-23T08:30:00-04:00',
    //         dSundayEnd: '2010-06-23T12:00:59-04:00',
    //         bPermanent: 'false',
    //         dUpdated: '2024-03-17T14:06:20.283Z',
    //         uTS: 'AAAAABxRTdU=',
    //         bFeatPromoAdvanced: 'false',
    //         iIdentifier: '0',
    //         sIdentifier: null,
    //         bUseInclusiveTaxation: true,
    //         bArchived: 'false',
    //         iBusinessType: '0',
    //         iSiteDataType: '0',
    //         sTaxNumber: '53 659 430 120',
    //         iFacilityUsage: '0',
    //         iFacilityOwnership: '0',
    //         iFacilityMgmt: '0',
    //         iFacilityLocType: '0',
    //         iMobileBungoRules: '0',
    //         dCreated: '2010-05-24T00:00:00-04:00',
    //         iOnLinePmtsAllowed: '1',
    //         iEdition: '1',
    //         iTerminalServices: '0',
    //         iDST: '0',
    //         iVerboseLogging: '0',
    //         iSiteLinkStoreTier: '1',
    //         sSLBillingRef: 'RAGNOR',
    //         iSubscriptionType: '0',
    //         tWeekdayStrt: '08:30:00',
    //         tWeekdayEnd: '05:00:59',
    //         tSaturdayStrt: '08:30:00',
    //         tSaturdayEnd: '04:00:59',
    //         tSundayStrt: '08:30:00',
    //         tSundayEnd: '12:00:59',
    //         rapidstorEnabled: true,
    //         ownerId: '48',
    //         languageId: '1',
    //         divisionId: '24',
    //         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //         hours: {
    //             officeMondayOpen: '9:00am',
    //             officeTuesdayOpen: '9:00am',
    //             officeWednesdayOpen: '9:00am',
    //             officeThursdayOpen: '9:00am',
    //             officeFridayOpen: '9:00am',
    //             officeSaturdayOpen: '9:00am',
    //             officeSundayOpen: '9:00am',
    //             officeMondayClose: '5:00pm',
    //             officeTuesdayClose: '5:00pm',
    //             officeWednesdayClose: '5:00pm',
    //             officeThursdayClose: '5:00pm',
    //             officeFridayClose: '5:00pm',
    //             officeSaturdayClose: '5:00pm',
    //             officeSundayClose: '5:00pm',
    //             gateOpen: '9:00am',
    //             gateClose: '5:00pm',
    //             gateOpenWeekend: '9:00am',
    //             gateCloseWeekend: '5:00pm',
    //             gateCloseSaturday: '5:00pm',
    //             gateCloseSunday: '5:00pm',
    //             gateOpenSaturday: '9:00am',
    //             gateOpenSunday: '9:00am',
    //         },
    //         skin: {
    //             accentColours: {
    //                 primary: '#FFE700',
    //             },
    //             mainColour: '#ED1F15',
    //             highlightColour: '#CFD8DC',
    //             moveinTimeRemaining: false,
    //             defaultUnitPicture: 'https://ik.imagekit.io/bytcx9plm/3x3_f.png',
    //             themeColour: ''
    //         },
    //         administrative: {
    //             boxshopEnabled: true,
    //             testMode: false,
    //             rslite: false,
    //             rsliteKey: 'N/A',
    //             refreshEnabled: false,
    //             availableForUse: false,
    //             insuranceEnabled: false,
    //             merchEnabled: false,
    //             carouselListing: false,
    //             useMtasForAuth: false,
    //             featureAllowReservationsWhenNoAvailability: false,
    //             spacerIntegration: false,
    //             couponCloning: false
    //         },
    //         rapidstor: {
    //             pushRate: false,
    //             marketingSurvey: {
    //                 use: true,
    //                 questions: {
    //                     whereHearAboutUs: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     distanceFromFacility: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whyStoring: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     customerType: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whatStoring: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whyStoringWithUs: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                 },
    //             },
    //             country: 'AU',
    //             unitListing: {
    //                 sortOrder: {
    //                     primary: 'size',
    //                     secondary: 'price',
    //                     tertiary: 'availability',
    //                 },
    //                 useMultilevel: false,
    //             },
    //             siteLogo:
    //                 'https://ik.imagekit.io/bytcx9plm/CRAG-NOR-logo-cltf2p5uq000301pi8cak97qz.png',
    //             allowOriginUrl: [],
    //             allowedCreditCardTypes: {
    //                 visa: true,
    //                 mastercard: true,
    //                 amex: true,
    //             },
    //             minAvailableUnits: 0,
    //             hideUnitsMinAvailable: true,
    //             noAvailableUnitsText: 'Call for Availability',
    //             hideQuickSearch: false,
    //             smallMediumSize: 7,
    //             mediumLargeSize: 13,
    //             moveinHideAcp: false,
    //             insuranceRequired: false,
    //             hideBoxshop: false,
    //             hideInsurance: false,
    //             hideLicense: false,
    //             hideLicenseState: true,
    //             hideDateOfBirth: true,
    //             hideState: false,
    //             hidePostalCode: false,
    //             autoOptInSms: false,
    //             currencySymbol: '$',
    //             sizeSymbol: 'm',
    //             groundFloor: 0,
    //             billingDefault: 'MonthlyAnniversary',
    //             shippingEnabled: false,
    //             legacyPickupLocationsEnabled: false,
    //             legacyPickupLocations: null,
    //             shippingInventoryItem: null,
    //             freeShippingDealEnabled: false,
    //             freeShippingDealAmount: 150,
    //             allowReservation: true,
    //             allowMoveIn: true,
    //             reservationNumberOfDaysInAdvanceLimit: 30,
    //             moveinNumberOfDaysInAdvanceLimit: 7,
    //             reservationNumberOfDaysInAdvanceChargeFee: 365,
    //             assistanceMoving: false,
    //             assistanceMovingEmailAddress: '',
    //             notificationsFromAddress: '',
    //             completeMoveinUrl: '',
    //             useESign: false,
    //             useAutoBilling: true,
    //             autoBillCheckedByDefault: false,
    //             doNotSendInvoiceSiteLinkWhenAutoBill: false,
    //             areaSizeSymbol: 'm²',
    //             allowReservationsWhenNoAvailability: false,
    //             attachInsuranceDocsToMoveInConfirmationEmail: false,
    //             attachLeaseToMoveInConfirmationEmail: true,
    //             attachReceiptToMoveInConfirmationEmail: true,
    //             autoESignRedirect: false,
    //             autoOptInSMS: false,
    //             bookOnlineDiscount: 0,
    //             boxshopCategoryAlphaOrder: false,
    //             boxshopPurchaseAttachmentName: '',
    //             boxshopPurchaseEmailSubject: '',
    //             boxshopTermsConditions: '',
    //             checkForExistingTenant: false,
    //             completeMoveinURL: '',
    //             currency: 'AUD',
    //             dateFormat: 'yyyy-MM-dd',
    //             datesClosed: '',
    //             delayedInsurance: {
    //                 enabled: false,
    //                 timings: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //             },
    //             directDebit: {
    //                 creditAmount: 0,
    //                 enabled: false,
    //             },
    //             documentVerification: {
    //                 enabled: false,
    //                 providerToUse: null,
    //                 providers: {
    //                     rapidId: {
    //                         label: 'RapidID',
    //                         token: null,
    //                     },
    //                 },
    //             },
    //             eSignInsuranceForm: {
    //                 sFormName: null,
    //             },
    //             eSignInsuranceFormName: '',
    //             eSignMoveInDocumentNames: [],
    //             eSignMoveInDocuments: [],
    //             eSignReturnUrl: '',
    //             emailSchedules: {
    //                 quoteUnlockFirstReminder: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //                 quoteUnlockSecondReminder: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //                 reservationNotMovedIn: {
    //                     days: null,
    //                     hours: null,
    //                     mintues: null,
    //                 },
    //                 quoteEmail: {
    //                     '1': {
    //                         subject: null,
    //                     },
    //                     '2': {
    //                         days: null,
    //                         hours: null,
    //                         minutes: null,
    //                         subject: null,
    //                     },
    //                     '3': {
    //                         days: null,
    //                         hours: null,
    //                         minutes: null,
    //                         subject: null,
    //                     },
    //                 },
    //             },
    //             enquiryAPI: {
    //                 numOptions: 3,
    //             },
    //             facilitySelfService: {
    //                 boxshop: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-boxshop.png',
    //                 },
    //                 enquiries: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-enquiries.png',
    //                 },
    //                 moveOut: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-moveout.png',
    //                 },
    //                 takePayment: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-take-payment.png',
    //                 },
    //             },
    //             features: {
    //                 boxshop: 'standard',
    //                 'carousel-unit-listing': 'standard',
    //                 'facility-self-service': 'standard',
    //                 'facility-staff-self-service': 'standard',
    //                 'movein-wizard': 'single-page',
    //                 'reservation-with-fee-wizard': 'standard',
    //                 'tenant-accounts': 'standard',
    //                 'tiered-unit-listing': 'standard',
    //                 'unit-listing': 'standard',
    //             },
    //             forceTaxInclusive: false,
    //             hidePrices: false,
    //             includeFutureMoveOut: false,
    //             includeReservedUnitsInOccupied: true,
    //             insuranceCustomFormat: '',
    //             insuranceEsignReturnUrl: '',
    //             insurancePolicyNumberRange: {
    //                 end: null,
    //                 start: null,
    //             },
    //             insurancePolicyNumberRefreshNum: null,
    //             insuranceSmsFollowUpContent: '',
    //             kioskUnitListing: 'standard',
    //             language: {
    //                 selectionOption: 'auto-detect',
    //             },
    //             locationPageUrl: '',
    //             moveinEmailSubject: '',
    //             moveinHideACP: false,
    //             moveinRedirectUrl: '',
    //             notificationsAdditionalBCCAddresses: [],
    //             notificationsAdditionalCCAddresses: [],
    //             notificationsFromName: '',
    //             notificationsReplyAddress: '',
    //             payLaterButtonText: 'Pay Later',
    //             payNowButtonText: 'Pay Now',
    //             paymentGateways: {
    //                 bypassSitelinkProcessing: false,
    //                 gatewayToUse: '',
    //                 paygate: {
    //                     countryCode: '',
    //                     currency: '',
    //                     encryptionKey: '',
    //                     locale: '',
    //                     payMethod: '',
    //                     paygateId: '',
    //                 },
    //                 paynamics: {
    //                     countryCode: 'PH',
    //                     currency: '',
    //                     merchantId: '',
    //                     merchantKey: '',
    //                     merchantTermsUrl: '',
    //                     paymentMethods: ['bn', 'cc', 'dp', 'gc', 'pp'],
    //                     secure3d: 'try3d',
    //                 },
    //                 paypal: {
    //                     clientId: '',
    //                     clientSecret: '',
    //                     currency: '',
    //                     useTestEnv: false,
    //                     force3dsCheck: false,
    //                 },
    //                 paytabs: {
    //                     countryCode: '',
    //                     merchantEmail: '',
    //                     merchantId: '',
    //                     merchantSiteUrl: '',
    //                     messageLanguage: '',
    //                     secretKey: '',
    //                     currency: ''
    //                 },
    //                 use: false,
    //                 r6Pay: {
    //                     currency: '',
    //                     useTestEnv: false,
    //                 },
    //             },
    //             pickupEnabled: true,
    //             quickReserveButtonText: 'Quick Reserve',
    //             recaptcha: {
    //                 enabled: false,
    //                 secretKey: '',
    //                 siteKey: '',
    //                 tolerance: 0.5,
    //             },
    //             requireAutobill: false,
    //             reservationEmailSubject: '',
    //             reservationExpireOccupancyValues: {
    //                 bands: [
    //                     {
    //                         days: 30,
    //                         from: 0,
    //                         to: 100,
    //                     },
    //                 ],
    //                 enabled: false,
    //             },
    //             reservationExpireReservationDays: 30,
    //             reservationPopupText: '',
    //             resetPasswordUrl: '',
    //             scheduleFollowUpEmails: false,
    //             sendReservationEmailOnFeeFailure: false,
    //             showAreaInsteadOfDimensions: false,
    //             showAutobillTerms: false,
    //             showMoveInDateLimitMessage: false,
    //             showPricesButtonText: 'Show Prices',
    //             showPricesShowNeeded: true,
    //             showVehicleQuickSearch: false,
    //             showWeeklyRates: false,
    //             siteLinkLeaseFields: [],
    //             siteOpeningDate: null,
    //             sitelinkCostRetrieveChargeNameSubstiutions: [],
    //             spaceCalculatorValues: {
    //                 bedroom: 4,
    //                 box: 0.05,
    //                 garage: 7,
    //                 highestValue: {
    //                     area: 20,
    //                     high: 30,
    //                     low: 18,
    //                 },
    //                 largeItem: 1.5,
    //                 largeRoom: 5,
    //                 lowestValue: {
    //                     area: 3,
    //                     high: 5,
    //                     low: 1,
    //                 },
    //                 room: 4,
    //                 smallItem: 0.5,
    //                 smallRoom: 3,
    //             },
    //             tenantAccounts: {
    //                 autoPayment: {
    //                     enabled: true,
    //                 },
    //                 enableMultiSiteLogin: {
    //                     enabled: false,
    //                 },
    //                 invoiceHistory: {
    //                     enabled: true,
    //                     showChargeBatch: false
    //                 },
    //                 makePayment: {
    //                     enabled: true,
    //                 },
    //                 notification: {
    //                     content: null,
    //                     ctaButton: {
    //                         text: null,
    //                     },
    //                     enabled: false,
    //                 },
    //                 paymentHistory: {
    //                     enabled: true,
    //                 },
    //                 tenantInfo: {
    //                     enabled: true,
    //                 },
    //                 uploadDocuments: {
    //                     enabled: true,
    //                     generalContent:
    //                         'Please select & upload the following documents as a pdf or image.',
    //                     proofOfAddress: {
    //                         content:
    //                             'Please upload a photo which has proof of your current address. Examples are bank statement, credit card statement or utility bill.',
    //                         enabled: true,
    //                         label: 'Proof of Address',
    //                     },
    //                     proofOfId: {
    //                         content:
    //                             "Please upload a photo of one of your identity documents such as your Driver's Licence or National Identity Card in JPG format.",
    //                         enabled: true,
    //                         label: 'Proof of Identification',
    //                     },
    //                     proofOfInsurance: {
    //                         content:
    //                             'Please upload a document which has proof of you being insured for your declared amount.',
    //                         enabled: true,
    //                         label: 'Proof of Insurance',
    //                     },
    //                 },
    //             },
    //             tieredPricing: {
    //                 cherryPickBasis: 'lowestRate',
    //                 hidePrices: false,
    //                 hideQuickSearch: false,
    //                 noAvailableUnitsText: 'Call for Availability',
    //                 showAvailableUnitsCount: false,
    //                 showPricesShowNeeded: true,
    //                 showTiersWithNoAvailableUnits: true,
    //                 showVehicleQuickSearch: false,
    //                 noAvailableUnitsSecondaryAction: '',
    //                 noAvailableUnitsSecondaryText: ''
    //             },
    //             twilio: {
    //                 accountSid: '',
    //                 authToken: '',
    //                 enabled: false,
    //                 senderId: '',
    //             },
    //             useBoxShopCoupons: false,
    //             useDealCoupons: false,
    //             useDescriptorTitle: false,
    //             useESignForInsuranceDocs: false,
    //             useWebRates: false,
    //             webhooks: {
    //                 docUpload: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 moveIn: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 pageLoad: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 reservation: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 reservationWithFee: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 leadFollowUp: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //             },
    //             wizards: {
    //                 moveinSingle: {
    //                     allowIdUpload: false,
    //                     allowProofOfAddressUpload: false,
    //                     allowProofOfInsuranceUpload: false,
    //                     hideAlternativeContact: true,
    //                     hideBoxshop: false,
    //                     hideDateOfBirth: true,
    //                     hideDriversLicence: false,
    //                     hideDriversLicenceState: true,
    //                     hideInsurance: false,
    //                     hideInsurancePicker: false,
    //                     hidePostalCode: false,
    //                     hideState: false,
    //                     insuranceAcceptancePopoverText: '',
    //                     insuranceAcceptanceText: 'By ticking this box you accept and agree; that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C’s below and understand the inclusions/exclusions of the policy.',
    //                     insuranceContent: '',
    //                     insuranceContentPopoverText: '',
    //                     insuranceManualEntry: false,
    //                     insuranceManualEntryRequired: false,
    //                     insuranceRefusedPopoverText: '',
    //                     insuranceRefusedText: 'By ticking this box, you are choosing not to be covered by insurance and acknowledge that we will not be held responsible for any damaged or lost goods during your rental period.',
    //                     insuranceRequired: false,
    //                     requireAlternativeContactPhoneNumberField: true,
    //                     hideDriversLicence_state: false,
    //                     allowSelfInsurance: false,
    //                     hide_postalCode: false,
    //                     distinguishCustomerTypes: false
    //                 },
    //                 moveinStandard: {
    //                     requireAlternativeContactPhoneNumberField: true,
    //                 },
    //                 reservationWithFeeStandard: {},
    //             },
    //             allowSaveQuote: false,
    //             saveQuoteButtonText: 'Save My Quote',
    //             saveQuotePopupText: '',
    //             ccSiteEmailInSaveQuote: true,
    //             creditCardForAutobill: {
    //                 enabled: true,
    //             },
    //         },
    //         fees: {
    //             moveOutNotice: 2,
    //             lateDays: 3,
    //             lateFee: 20,
    //             adminFee: 20,
    //             nsfFee: 20,
    //             cleaningFee: 50,
    //             securityDeposit: 100,
    //         },
    //         OwnerID: '48',
    //         LanguageID: '1',
    //         DivisionID: '24',
    //         bForcePushRates: '0',
    //         iWebRatesType: '0',
    //         collections: {
    //             site: {
    //                 name: 'site',
    //                 job: 'CRAG/NOR/site',
    //                 status: 'finished',
    //                 timestamp: 1710547699145,
    //             },
    //             unitTypeGroup: {
    //                 name: 'unitTypeGroup',
    //                 job: 'CRAG/NOR/unitTypeGroup',
    //                 status: 'finished',
    //                 timestamp: 1710547699144,
    //             },
    //             paymentSettings: {
    //                 name: 'paymentSettings',
    //                 job: 'CRAG/NOR/paymentSettings',
    //                 status: 'finished',
    //                 timestamp: 1710547699145,
    //             },
    //             inventory: {
    //                 name: 'inventory',
    //                 job: 'CRAG/NOR/inventory',
    //                 status: 'finished',
    //                 timestamp: 1710547699145,
    //             },
    //             chargeDescription: {
    //                 name: 'chargeDescription',
    //                 job: 'CRAG/NOR/chargeDescription',
    //                 status: 'finished',
    //                 timestamp: 1710547699145,
    //             },
    //             paymentTypes: {
    //                 name: 'paymentTypes',
    //                 job: 'CRAG/NOR/paymentTypes',
    //                 status: 'finished',
    //                 timestamp: 1710547699146,
    //             },
    //             marketingSource: {
    //                 name: 'marketingSource',
    //                 job: 'CRAG/NOR/marketingSource',
    //                 status: 'finished',
    //                 timestamp: 1710547699145,
    //             },
    //             discountPlan: {
    //                 name: 'discountPlan',
    //                 job: 'CRAG/NOR/discountPlan',
    //                 status: 'finished',
    //                 timestamp: 1710547699145,
    //             },
    //             form: {
    //                 name: 'form',
    //                 job: 'CRAG/NOR/form',
    //                 status: 'finished',
    //                 timestamp: 1710547699146,
    //             },
    //             unitsFull: {
    //                 name: 'unitsFull',
    //                 job: 'CRAG/NOR/unitsFull',
    //                 status: 'finished',
    //                 timestamp: 1710547699144,
    //             },
    //             insuranceCoverage: {
    //                 name: 'insuranceCoverage',
    //                 job: 'CRAG/NOR/insuranceCoverage',
    //                 status: 'finished',
    //                 timestamp: 1710547699145,
    //             },
    //         },
    //         changeToken:
    //             'fb5cea657ee101d3dbddbb2fb39a4fde9734a54d516c689b0afa431e9833891c1c20b20a9c9ded9eb7186ada1b85df03',
    //         changedAt: '2024-03-17T18:14:30.124Z',
    //         deleted: false,
    //         friendlyName: null,
    //         originalName: 'U-Store-It Norwood',
    //         pdfFonts: {
    //             insuranceDocs: 'Arial',
    //             lease: 'Arial',
    //             receipt: 'Arial',
    //         },
    //         scaConfiguration: {},
    //         personas: [
    //             {
    //                 _id: '65e69e4d7689a584c94d3546',
    //                 enabled: true,
    //                 name: 'Personal',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'personal',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //             {
    //                 _id: '65e69e4d7689a5b8154d3548',
    //                 enabled: true,
    //                 name: 'Vehicle',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'vehicle',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //             {
    //                 _id: '65e69e4d7689a5152e4d3547',
    //                 enabled: true,
    //                 name: 'Business',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'business',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //         ],
    //         sCorpCode: 'CRAG',
    //     },
    //     {
    //         SiteID: 1836,
    //         sLocationCode: 'PAR',
    //         sGlobalSiteNum: '14544',
    //         iMobileType: '0',
    //         iRegionalOptions: 1,
    //         iOnLineChargeType: '0',
    //         bFeatMobileStorage: 'false',
    //         iGMTTimeOffset: 10,
    //         sLocationDesc: null,
    //         sSiteIDCode: null,
    //         sSiteRegionCode: null,
    //         sContactName: 'Mark Whitehead',
    //         sEmailAddress: 'parahills@ustoreit.com.au',
    //         sSiteName: 'U-Store-It Para Hills',
    //         sSiteAddr1: '1367 Main North Road',
    //         sSiteAddr2: null,
    //         sSiteCity: 'Para Hills West',
    //         sSiteRegion: 'SA',
    //         sSitePostalCode: '5096',
    //         sSiteCountry: 'AUS',
    //         sSitePhone: '08 8283 3355',
    //         sSiteFAX: '.',
    //         sWebSiteURL: null,
    //         iFeatMaxUnits: '1250',
    //         bFeatGate: 'true',
    //         bFeatKiosk: 'true',
    //         bFeatRevMgmt: 'true',
    //         bFeatCreditCards: 'true',
    //         bFeatCorpOffice: 'true',
    //         bFeatAccounting: 'true',
    //         bFeatRecordStorage: 'false',
    //         bFeatACH: 'true',
    //         dACHStatus: '2010-10-21T22:36:37.827-04:00',
    //         bLiteVersion: 'false',
    //         bTrial: 'false',
    //         bSubscription: 'false',
    //         bSiteDisabled: 'false',
    //         dGateUpdated: '2024-03-12T11:52:23.657-04:00',
    //         dOvernightProcess: '2024-03-16T10:05:59.613-04:00',
    //         sLegalName: 'U-Store-It Pty Ltd',
    //         bZipCodeData_Use: 'false',
    //         dcLongitude: '138.6412580000',
    //         dcLatitude: '-34.7997750000',
    //         bClosedWeekdays: 'false',
    //         bClosedSaturday: 'false',
    //         bClosedSunday: 'true',
    //         dWeekdayStrt: '2010-06-09T08:30:00-04:00',
    //         dWeekdayEnd: '2010-06-09T17:00:59-04:00',
    //         dSaturdayStrt: '2010-06-09T08:30:00-04:00',
    //         dSaturdayEnd: '2010-06-09T16:00:59-04:00',
    //         dSundayStrt: '2010-06-09T08:30:00-04:00',
    //         dSundayEnd: '2010-06-09T12:00:59-04:00',
    //         bPermanent: 'false',
    //         dUpdated: '2024-03-16T14:05:59.613Z',
    //         uTS: 'AAAAABxQgqw=',
    //         bFeatPromoAdvanced: 'false',
    //         iIdentifier: '0',
    //         sIdentifier: null,
    //         bUseInclusiveTaxation: true,
    //         bArchived: 'false',
    //         iBusinessType: '-35',
    //         iSiteDataType: '0',
    //         sTaxNumber: '53 659 430 120',
    //         iFacilityUsage: '0',
    //         iFacilityOwnership: '0',
    //         iFacilityMgmt: '0',
    //         iFacilityLocType: '0',
    //         iMobileBungoRules: '0',
    //         dCreated: '2010-06-07T00:00:00-04:00',
    //         iOnLinePmtsAllowed: '1',
    //         iEdition: '1',
    //         iTerminalServices: '0',
    //         iDST: '0',
    //         iVerboseLogging: '0',
    //         iSiteLinkStoreTier: '1',
    //         sSLBillingRef: 'RAGPAR',
    //         iSubscriptionType: '0',
    //         tWeekdayStrt: '08:30:00',
    //         tWeekdayEnd: '17:00:59',
    //         tSaturdayStrt: '08:30:00',
    //         tSaturdayEnd: '16:00:59',
    //         tSundayStrt: '08:30:00',
    //         tSundayEnd: '12:00:59',
    //         rapidstorEnabled: true,
    //         bForcePushRates: '0',
    //         iWebRatesType: '0',
    //         ownerId: '48',
    //         languageId: '1',
    //         divisionId: '24',
    //         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //         hours: {
    //             officeMondayOpen: '8:30am',
    //             officeTuesdayOpen: '8:30am',
    //             officeWednesdayOpen: '8:30am',
    //             officeThursdayOpen: '8:30am',
    //             officeFridayOpen: '8:30am',
    //             officeSaturdayOpen: '8:30am',
    //             officeSundayOpen: 'Closed',
    //             officeMondayClose: '5:00pm',
    //             officeTuesdayClose: '5:00pm',
    //             officeWednesdayClose: '5:00pm',
    //             officeThursdayClose: '5:00pm',
    //             officeFridayClose: '5:00pm',
    //             officeSaturdayClose: '4:00pm',
    //             officeSundayClose: '',
    //             gateOpen: '5:00am',
    //             gateClose: '10:00pm',
    //             gateOpenWeekend: '5:00am',
    //             gateCloseWeekend: '10:00pm',
    //             gateCloseSaturday: '5:00pm',
    //             gateCloseSunday: '5:00pm',
    //             gateOpenSaturday: '9:00am',
    //             gateOpenSunday: '9:00am',
    //         },
    //         skin: {
    //             accentColours: {
    //                 primary: '#FFE700',
    //             },
    //             defaultUnitPicture: 'https://ik.imagekit.io/bytcx9plm/3x3_f.png',
    //             mainColour: '#ED1F15',
    //             highlightColour: '#CFD8DC',
    //             moveinTimeRemaining: false,
    //             themeColour: ''
    //         },
    //         administrative: {
    //             boxshopEnabled: true,
    //             testMode: false,
    //             rslite: false,
    //             rsliteKey: 'N/A',
    //             refreshEnabled: false,
    //             availableForUse: false,
    //             insuranceEnabled: false,
    //             merchEnabled: false,
    //             carouselListing: false,
    //             useMtasForAuth: false,
    //             featureAllowReservationsWhenNoAvailability: false,
    //             spacerIntegration: false,
    //             couponCloning: false
    //         },
    //         rapidstor: {
    //             pushRate: false,
    //             marketingSurvey: {
    //                 use: true,
    //                 questions: {
    //                     whereHearAboutUs: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     distanceFromFacility: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whyStoring: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     customerType: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whatStoring: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                     whyStoringWithUs: {
    //                         display: true,
    //                         required: true,
    //                     },
    //                 },
    //             },
    //             country: 'AU',
    //             unitListing: {
    //                 sortOrder: {
    //                     primary: 'size',
    //                     secondary: 'price',
    //                     tertiary: 'availability',
    //                 },
    //                 useMultilevel: false,
    //             },
    //             siteLogo:
    //                 'https://ik.imagekit.io/bytcx9plm/CRAG-PAR-logo-cjnmbqkvp0001s8moqkryk9n5.png',
    //             allowOriginUrl: ['https://www.ustoreit.com.au'],
    //             allowedCreditCardTypes: {
    //                 visa: true,
    //                 mastercard: true,
    //                 amex: true,
    //             },
    //             siteLinkLeaseFields: [],
    //             facilitySelfService: {
    //                 enquiries: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-enquiries.png',
    //                 },
    //                 takePayment: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-take-payment.png',
    //                 },
    //                 moveOut: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-moveout.png',
    //                 },
    //                 boxshop: {
    //                     background:
    //                         'https://ik.imagekit.io/bytcx9plm/facility-self-service-default-boxshop.png',
    //                 },
    //             },
    //             tieredPricing: {
    //                 showTiersWithNoAvailableUnits: true,
    //                 noAvailableUnitsText: 'Call for Availability',
    //                 cherryPickBasis: 'lowestRate',
    //                 hidePrices: false,
    //                 hideQuickSearch: false,
    //                 showAvailableUnitsCount: false,
    //                 showPricesShowNeeded: true,
    //                 showVehicleQuickSearch: false,
    //                 noAvailableUnitsSecondaryAction: '',
    //                 noAvailableUnitsSecondaryText: ''
    //             },
    //             language: {
    //                 selectionOption: 'auto-detect',
    //             },
    //             useBoxShopCoupons: false,
    //             useDealCoupons: false,
    //             wizards: {
    //                 moveinSingle: {
    //                     hideAlternativeContact: false,
    //                     hideBoxshop: false,
    //                     hideInsurance: false,
    //                     insuranceRequired: false,
    //                     hideDriversLicence: false,
    //                     hideDriversLicenceState: true,
    //                     hideDateOfBirth: true,
    //                     hideState: false,
    //                     hidePostalCode: false,
    //                     allowIdUpload: false,
    //                     allowProofOfAddressUpload: false,
    //                     allowProofOfInsuranceUpload: false,
    //                     hideInsurancePicker: false,
    //                     insuranceAcceptancePopoverText: '',
    //                     insuranceAcceptanceText: 'By ticking this box you accept and agree; that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C’s below and understand the inclusions/exclusions of the policy.',
    //                     insuranceContent: '',
    //                     insuranceContentPopoverText: '',
    //                     insuranceManualEntry: false,
    //                     insuranceManualEntryRequired: false,
    //                     insuranceRefusedPopoverText: '',
    //                     insuranceRefusedText: 'By ticking this box, you are choosing not to be covered by insurance and acknowledge that we will not be held responsible for any damaged or lost goods during your rental period.',
    //                     requireAlternativeContactPhoneNumberField: true,
    //                     hideDriversLicence_state: false,
    //                     allowSelfInsurance: false,
    //                     hide_postalCode: false,
    //                     distinguishCustomerTypes: false
    //                 },
    //                 moveinStandard: {
    //                     requireAlternativeContactPhoneNumberField: true,
    //                 },
    //                 reservationWithFeeStandard: {},
    //             },
    //             features: {
    //                 'movein-wizard': 'single-page',
    //                 'unit-listing': 'standard',
    //                 boxshop: 'standard',
    //                 'reservation-with-fee-wizard': 'standard',
    //                 'tiered-unit-listing': 'standard',
    //                 'facility-self-service': 'standard',
    //                 'facility-staff-self-service': 'standard',
    //                 'tenant-accounts': 'standard',
    //                 'carousel-unit-listing': 'standard',
    //             },
    //             paymentGateways: {
    //                 use: false,
    //                 gatewayToUse: '',
    //                 paypal: {
    //                     currency: '',
    //                     clientId: '',
    //                     clientSecret: '',
    //                     useTestEnv: false,
    //                     force3dsCheck: false,
    //                 },
    //                 paytabs: {
    //                     merchantEmail: '',
    //                     secretKey: '',
    //                     merchantSiteUrl: '',
    //                     countryCode: '',
    //                     messageLanguage: '',
    //                     merchantId: '',
    //                     currency: ''
    //                 },
    //                 bypassSitelinkProcessing: false,
    //                 paygate: {
    //                     countryCode: '',
    //                     currency: '',
    //                     encryptionKey: '',
    //                     locale: '',
    //                     payMethod: '',
    //                     paygateId: '',
    //                 },
    //                 paynamics: {
    //                     countryCode: 'PH',
    //                     currency: '',
    //                     merchantId: '',
    //                     merchantKey: '',
    //                     merchantTermsUrl: '',
    //                     paymentMethods: ['bn', 'cc', 'dp', 'gc', 'pp'],
    //                     secure3d: 'try3d',
    //                 },
    //                 r6Pay: {
    //                     currency: '',
    //                     useTestEnv: false,
    //                 },
    //             },
    //             minAvailableUnits: 1,
    //             hideUnitsMinAvailable: false,
    //             noAvailableUnitsText: 'Call for Availability',
    //             hideQuickSearch: false,
    //             smallMediumSize: 2,
    //             mediumLargeSize: 13,
    //             moveinHideAcp: false,
    //             insuranceRequired: false,
    //             hideBoxshop: false,
    //             hideInsurance: false,
    //             hideLicense: false,
    //             hideLicenseState: true,
    //             hideDateOfBirth: true,
    //             hideState: false,
    //             hidePostalCode: false,
    //             autoOptInSms: false,
    //             currencySymbol: '$',
    //             sizeSymbol: 'm',
    //             groundFloor: '1',
    //             billingDefault: 'MonthlyAnniversary',
    //             shippingEnabled: false,
    //             legacyPickupLocationsEnabled: false,
    //             legacyPickupLocations: null,
    //             shippingInventoryItem: null,
    //             freeShippingDealEnabled: false,
    //             freeShippingDealAmount: 150,
    //             allowReservation: true,
    //             allowMoveIn: false,
    //             reservationNumberOfDaysInAdvanceLimit: 28,
    //             moveinNumberOfDaysInAdvanceLimit: 5,
    //             reservationNumberOfDaysInAdvanceChargeFee: 365,
    //             assistanceMoving: false,
    //             assistanceMovingEmailAddress: '',
    //             notificationsFromAddress: 'parahillswest@ustoreit.com.au',
    //             completeMoveinUrl: '',
    //             useESign: false,
    //             useAutoBilling: true,
    //             autoBillCheckedByDefault: false,
    //             doNotSendInvoiceSiteLinkWhenAutoBill: false,
    //             quickReserveButtonText: 'Get Quote',
    //             reservationExpireReservationDays: 30,
    //             notificationsAdditionalCcAddresses: [],
    //             areaSizeSymbol: 'm²',
    //             allowReservationsWhenNoAvailability: false,
    //             attachInsuranceDocsToMoveInConfirmationEmail: false,
    //             attachLeaseToMoveInConfirmationEmail: true,
    //             attachReceiptToMoveInConfirmationEmail: true,
    //             autoESignRedirect: false,
    //             autoOptInSMS: false,
    //             bookOnlineDiscount: 0,
    //             boxshopCategoryAlphaOrder: false,
    //             boxshopPurchaseAttachmentName: '',
    //             boxshopPurchaseEmailSubject: '',
    //             boxshopTermsConditions: '',
    //             checkForExistingTenant: false,
    //             completeMoveinURL: '',
    //             currency: 'AUD',
    //             dateFormat: 'yyyy-MM-dd',
    //             datesClosed: '',
    //             delayedInsurance: {
    //                 enabled: false,
    //                 timings: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //             },
    //             documentVerification: {
    //                 enabled: false,
    //                 providerToUse: null,
    //                 providers: {
    //                     rapidId: {
    //                         label: 'RapidID',
    //                         token: null,
    //                     },
    //                 },
    //             },
    //             eSignInsuranceForm: {
    //                 sFormName: null,
    //             },
    //             eSignInsuranceFormName: '',
    //             eSignMoveInDocumentNames: [],
    //             eSignMoveInDocuments: [],
    //             eSignReturnUrl: '',
    //             emailSchedules: {
    //                 quoteUnlockFirstReminder: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //                 quoteUnlockSecondReminder: {
    //                     days: null,
    //                     hours: null,
    //                     minutes: null,
    //                 },
    //                 reservationNotMovedIn: {
    //                     days: null,
    //                     hours: null,
    //                     mintues: null,
    //                 },
    //                 quoteEmail: {
    //                     '1': {
    //                         subject: null,
    //                     },
    //                     '2': {
    //                         days: null,
    //                         hours: null,
    //                         minutes: null,
    //                         subject: null,
    //                     },
    //                     '3': {
    //                         days: null,
    //                         hours: null,
    //                         minutes: null,
    //                         subject: null,
    //                     },
    //                 },
    //             },
    //             enquiryAPI: {
    //                 numOptions: 3,
    //             },
    //             forceTaxInclusive: false,
    //             hidePrices: false,
    //             includeFutureMoveOut: false,
    //             includeReservedUnitsInOccupied: true,
    //             insuranceCustomFormat: '',
    //             insuranceEsignReturnUrl: '',
    //             insurancePolicyNumberRange: {
    //                 end: null,
    //                 start: null,
    //             },
    //             insurancePolicyNumberRefreshNum: null,
    //             insuranceSmsFollowUpContent: '',
    //             kioskUnitListing: 'standard',
    //             locationPageUrl: '',
    //             moveinEmailSubject: '',
    //             moveinHideACP: false,
    //             moveinRedirectUrl: '',
    //             notificationsAdditionalBCCAddresses: [],
    //             notificationsAdditionalCCAddresses: [],
    //             notificationsFromName: '',
    //             notificationsReplyAddress: '',
    //             payLaterButtonText: 'Pay Later',
    //             payNowButtonText: 'Pay Now',
    //             pickupEnabled: true,
    //             recaptcha: {
    //                 enabled: false,
    //                 secretKey: '',
    //                 siteKey: '',
    //                 tolerance: 0.5,
    //             },
    //             reservationEmailSubject: '',
    //             reservationExpireOccupancyValues: {
    //                 bands: [
    //                     {
    //                         days: 30,
    //                         from: 0,
    //                         to: 100,
    //                     },
    //                 ],
    //                 enabled: false,
    //             },
    //             reservationPopupText: '',
    //             resetPasswordUrl: '',
    //             scheduleFollowUpEmails: false,
    //             showAreaInsteadOfDimensions: false,
    //             showAutobillTerms: false,
    //             showMoveInDateLimitMessage: false,
    //             showPricesButtonText: 'Show Prices',
    //             showPricesShowNeeded: true,
    //             showVehicleQuickSearch: false,
    //             showWeeklyRates: false,
    //             siteOpeningDate: null,
    //             sitelinkCostRetrieveChargeNameSubstiutions: [],
    //             spaceCalculatorValues: {
    //                 bedroom: 4,
    //                 box: 0.05,
    //                 garage: 7,
    //                 highestValue: {
    //                     area: 20,
    //                     high: 30,
    //                     low: 18,
    //                 },
    //                 largeItem: 1.5,
    //                 largeRoom: 5,
    //                 lowestValue: {
    //                     area: 3,
    //                     high: 5,
    //                     low: 1,
    //                 },
    //                 room: 4,
    //                 smallItem: 0.5,
    //                 smallRoom: 3,
    //             },
    //             tenantAccounts: {
    //                 autoPayment: {
    //                     enabled: true,
    //                 },
    //                 invoiceHistory: {
    //                     enabled: true,
    //                     showChargeBatch: false
    //                 },
    //                 makePayment: {
    //                     enabled: true,
    //                 },
    //                 paymentHistory: {
    //                     enabled: true,
    //                 },
    //                 tenantInfo: {
    //                     enabled: true,
    //                 },
    //                 uploadDocuments: {
    //                     enabled: true,
    //                     generalContent:
    //                         'Please select & upload the following documents as a pdf or image.',
    //                     proofOfAddress: {
    //                         content:
    //                             'Please upload a photo which has proof of your current address. Examples are bank statement, credit card statement or utility bill.',
    //                         enabled: true,
    //                         label: 'Proof of Address',
    //                     },
    //                     proofOfId: {
    //                         content:
    //                             "Please upload a photo of one of your identity documents such as your Driver's Licence or National Identity Card in JPG format.",
    //                         enabled: true,
    //                         label: 'Proof of Identification',
    //                     },
    //                     proofOfInsurance: {
    //                         content:
    //                             'Please upload a document which has proof of you being insured for your declared amount.',
    //                         enabled: true,
    //                         label: 'Proof of Insurance',
    //                     },
    //                 },
    //                 enableMultiSiteLogin: {
    //                     enabled: false,
    //                 },
    //                 notification: {
    //                     content: null,
    //                     ctaButton: {
    //                         text: null,
    //                     },
    //                     enabled: false,
    //                 },
    //             },
    //             twilio: {
    //                 accountSid: '',
    //                 authToken: '',
    //                 enabled: false,
    //                 senderId: '',
    //             },
    //             useDescriptorTitle: false,
    //             useESignForInsuranceDocs: false,
    //             useWebRates: false,
    //             webhooks: {
    //                 docUpload: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 moveIn: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 pageLoad: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 reservation: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 reservationWithFee: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //                 leadFollowUp: {
    //                     enabled: false,
    //                     template: '',
    //                     url: '',
    //                 },
    //             },
    //             directDebit: {
    //                 creditAmount: 0,
    //                 enabled: false,
    //             },
    //             requireAutobill: false,
    //             sendReservationEmailOnFeeFailure: false,
    //             allowSaveQuote: false,
    //             saveQuoteButtonText: 'Save My Quote',
    //             saveQuotePopupText: '',
    //             ccSiteEmailInSaveQuote: true,
    //             creditCardForAutobill: {
    //                 enabled: true,
    //             },
    //         },
    //         fees: {
    //             moveOutNotice: 7,
    //             lateDays: 14,
    //             lateFee: 15,
    //             adminFee: 0,
    //             nsfFee: 11,
    //             cleaningFee: '15',
    //             securityDeposit: 0,
    //         },
    //         changedAt: '2024-03-17T02:37:35.533Z',
    //         changeToken:
    //             'a5cde7865967f3e90294f645f70b0dc9e7a81c175bca60fbcfb37f33d24445b0d7214b9c931e673fb0dc67e55857ccbd',
    //         deleted: false,
    //         DivisionID: '24',
    //         LanguageID: '1',
    //         OwnerID: '48',
    //         scaConfiguration: {},
    //         pdfFonts: {
    //             insuranceDocs: 'Arial',
    //             lease: 'Arial',
    //             receipt: 'Arial',
    //         },
    //         collections: {
    //             unitTypeGroup: {
    //                 name: 'unitTypeGroup',
    //                 job: 'CRAG/PAR/unitTypeGroup',
    //                 status: 'finished',
    //                 timestamp: 1710547699146,
    //             },
    //             insuranceCoverage: {
    //                 name: 'insuranceCoverage',
    //                 job: 'CRAG/PAR/insuranceCoverage',
    //                 status: 'finished',
    //                 timestamp: 1710547699146,
    //             },
    //             site: {
    //                 name: 'site',
    //                 job: 'CRAG/PAR/site',
    //                 status: 'finished',
    //                 timestamp: 1710547699146,
    //             },
    //             paymentSettings: {
    //                 name: 'paymentSettings',
    //                 job: 'CRAG/PAR/paymentSettings',
    //                 status: 'finished',
    //                 timestamp: 1710547699148,
    //             },
    //             paymentTypes: {
    //                 name: 'paymentTypes',
    //                 job: 'CRAG/PAR/paymentTypes',
    //                 status: 'finished',
    //                 timestamp: 1710547699148,
    //             },
    //             inventory: {
    //                 name: 'inventory',
    //                 job: 'CRAG/PAR/inventory',
    //                 status: 'finished',
    //                 timestamp: 1710547699146,
    //             },
    //             form: {
    //                 name: 'form',
    //                 job: 'CRAG/PAR/form',
    //                 status: 'finished',
    //                 timestamp: 1710547699148,
    //             },
    //             discountPlan: {
    //                 name: 'discountPlan',
    //                 job: 'CRAG/PAR/discountPlan',
    //                 status: 'finished',
    //                 timestamp: 1710547699148,
    //             },
    //             marketingSource: {
    //                 name: 'marketingSource',
    //                 job: 'CRAG/PAR/marketingSource',
    //                 status: 'finished',
    //                 timestamp: 1710547699148,
    //             },
    //             unitsFull: {
    //                 name: 'unitsFull',
    //                 job: 'CRAG/PAR/unitsFull',
    //                 status: 'finished',
    //                 timestamp: 1710547699146,
    //             },
    //             chargeDescription: {
    //                 name: 'chargeDescription',
    //                 job: 'CRAG/PAR/chargeDescription',
    //                 status: 'finished',
    //                 timestamp: 1710461195211,
    //             },
    //         },
    //         friendlyName: null,
    //         originalName: 'U-Store-It Para Hills',
    //         personas: [
    //             {
    //                 _id: '65e69e4d7689a584c94d3546',
    //                 enabled: true,
    //                 name: 'Personal',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'personal',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //             {
    //                 _id: '65e69e4d7689a5b8154d3548',
    //                 enabled: true,
    //                 name: 'Vehicle',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'vehicle',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //             {
    //                 _id: '65e69e4d7689a5152e4d3547',
    //                 enabled: true,
    //                 name: 'Business',
    //                 parameters: [
    //                     {
    //                         name: 'personatype',
    //                         value: 'business',
    //                     },
    //                 ],
    //                 sites: [
    //                     {
    //                         sLocationCode: 'ASH',
    //                         token: 'd0ad6c868f80ff6e7116757e85670b90e9cb31bd02ee168ba6dee05765e9c75f355255d8fa6ce181475c935bc9cfac29',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'BAR',
    //                         token: '5728c2ef86c2eb199eeec3cf7a4404b5a1eb3c4637a9420895196f9eb7709b223498718eb34b1f46e78f18cf49b6b867',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'GEP',
    //                         token: 'beb9332c4269d90952bbae6a51ed8401a013410f9717b0570a2c247456b9cc51b5c688ac10a63f286354b9a574cade5b',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LON',
    //                         token: '5ed36535e4fd1619d3f284835b155e202ced465481f267f5d90ec92b8c226660e406384acde7afb5537906ac9361de76',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'LSETUPS',
    //                         token: 'f9fd89a897f9e08ba0b36cd02a0960ff6d1f530a6af17631418694dec01d87318bd78f5059fd55e7430a8df06003603a',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'MEL',
    //                         token: 'bf979fe9491cd7be39e5369149b7a450b6278e3b0d6192ff96be97931236fd9bfbf945f6df514c888498336babe400c0',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'NOR',
    //                         token: '7ec931e48f50d35f97ffde9e26ef8236cf7454f48a9fc7e969f273d383960bc4a3f871e0d6e0837ede8bc5246397be05',
    //                         deals: [],
    //                     },
    //                     {
    //                         sLocationCode: 'PAR',
    //                         token: '3094ce7be802d310e6f5fda781510132a168891d758505b489fb51b8909e29401573802aba29253d0b15615e5b64d48a',
    //                         deals: [],
    //                     },
    //                 ],
    //             },
    //         ],
    //         sCorpCode: 'CRAG',
    //     },
];
export default defaultLocations;
